// ----------------------------------------------------------------------
import styles from './BrandOwner.module.css';
import './BrandOwner.module.css';
import ReactApexChart from 'react-apexcharts';

import { Card, CardContent, Avatar } from '@mui/material';
import { useState, useEffect, useRef } from 'react';
import GlobalModal from 'src/Modals/GlobalModal';
import axiosInstance from 'src/axiosInstance';
import toast from 'react-hot-toast';
import moment from 'moment';
import { useNavigate, useParams } from 'react-router-dom';
import bus from 'src/bus';
import Filter2 from 'src/pages/Filter/Filter2';
import { BallTriangle } from 'react-loader-spinner';
import CircularProgress from '@mui/material/CircularProgress';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';

import { GoogleMapHeatmap } from '../../components';
import { useAuth } from 'src/hooks/useAuth';

// ----------------------------------------------------------------------

export default function DashboardAppPage() {
  const { id } = useParams();
  const { data } = useAuth();
  const userData = JSON.parse(localStorage.getItem('auth'));
  const [brand, setBrand] = useState(
    JSON.parse(localStorage.getItem('selected_user_insight')) || ''
  );
  const [modalOpen, setModalOpen] = useState(false);
  const [modalOpen2, setModalOpen2] = useState(false);
  const [modalOpen3, setModalOpen3] = useState(false);
  const [isPending, setIsPending] = useState(false);
  const [isPending1, setIsPending1] = useState(false);
  const [isDepStatPending, setIsDepStatPending] = useState(false);
  const [isRevGrowthPending, setIsRevGrowthPending] = useState(false);
  const [dataFilter, setDataFilter] = useState('alltime');
  const [country, setCountry] = useState('Nigeria');
  const [categoriesData, setCategoriesData] = useState([]);
  const [productData, setProductData] = useState([]);
  const [mapData, setMapData] = useState([]);
  const [productCatData, setProductCatData] = useState([]);
  const [catProductData, setCatProductData] = useState([]);
  const [brandData, setBrandData] = useState([]);
  const [states, setStates] = useState([]);
  const [state, setState] = useState('');
  const [searchStates2, setSearchStates2] = useState('');
  const [searchStates3, setSearchStates3] = useState('');
  const [selectedProductIds, setSelectedProductIds] = useState([]);
  const [selectedState, setSelectedState] = useState([]);
  const [selectedStates, setSelectedStates] = useState([]);
  const [selectAllProduct, setSelectAllProduct] = useState(false);
  const [selectAllStates, setSelectAllStates] = useState(false);
  const [isProductPending, setIsProductPending] = useState(false);
  const [isPurchasedProductPending, setIsPurchasedProductPending] =
    useState(false);
  const [isProductSalesPending, setIsProductSalesPending] = useState(false);
  const [isBPPending, setIsBPPending] = useState(false);
  const [isOBLPending, setIsOBLPending] = useState(false);
  const [isHighestPerformingStorePending, setIsHighestPerformingStorePending] =
    useState(false);
  const [isTrendsOfPurchasePending, setIsTrendsOfPurchasePending] =
    useState(false);
  const [isMarketSharePending, setIsMarketSharePending] = useState(false);
  const [loadingState, setLoadingState] = useState(false);
  const [cardLoader, setCardLoader] = useState(false);
  const [cardsData, setCardsData] = useState({
    abandonOrder: {
      boldCount: 0,
      percentageDiff: 0,
      smallCount: 0,
    },
    completedOrder: {
      boldCount: 0,
      percentageDiff: 0,
      smallCount: 0,
    },
    grossMerchandiseValue: {
      boldCount: 0,
      percentageDiff: 0,
      smallCount: 0,
    },
    netMerchandiseValue: {
      boldCount: 0,
      percentageDiff: 0,
      smallCount: 0,
    },
    totalOrder: {
      boldCount: 0,
      percentageDiff: 0,
      smallCount: 0,
    },
  });

  const allChartData = [
    { value: 'd_s', name: 'Depletion Stats' },
    { value: 'p_p_b_s_v', name: 'Purchased Product by SKU Variation' },
    // {value: 'p_p_b_b', name: 'Purchased product by brand'},
    { value: 'h_p_l', name: 'High Performing Location' },
    { value: 'h_p_s', name: 'High Performing Store' },
    { value: 't_o_p', name: 'Trends of Purchases' },
    { value: 'm_s', name: 'Market Share' },
    // {value: 's_b_p', name: 'Shopper buying power'},
    { value: 'o_b_l', name: 'Orders by Location (Heat Map)' },
  ];

  const [selectedProductCatIds, setSelectedProductCatIds] = useState([]);
  const [isProductCatPending, setIsProductCatPending] = useState(false);
  const [isCategoryPending, setIsCategoryPending] = useState(false);
  const [selectedCategoryIds, setSelectedCategoryIds] = useState([]);
  const [searchBrands, setSearchBrands] = useState('');
  const [selectedState2, setSelectedState2] = useState('');
  const [selectedState3, setSelectedState3] = useState('');
  const [selectAllBrand, setSelectAllBrand] = useState(false);
  const [categoryProductId, setCategoryProductId] = useState('');
  const [selectAllProductCategory, setSelectAllProductCategory] =
    useState(false);
  const [categorySelectedIds, setCategorySelectedIds] = useState([]);
  const [categoryPending, setCategoryPending] = useState(false);
  const [searchCategory, setSearchCategory] = useState('');
  const [searchProducts, setSearchProducts] = useState('');
  const [searchStates, setSearchStates] = useState('');
  const navigate = useNavigate();
  const notifyError = (err) => toast.error(err);
  const [statFilter1, setStatFilter1] = useState(false);
  const [statFilter01, setStatFilter01] = useState(false);
  const [statFilter2, setStatFilter2] = useState(false);
  const [currentYear, setCurrentYear] = useState(new Date().getFullYear());
  const [selectedYear, setSelectedYear] = useState(currentYear);
  const [selectedYear1, setSelectedYear1] = useState(currentYear);
  const [modalVal, setModalVal1] = useState('');

  const [selectedTab, setSelectedTab] = useState(1);
  const [selectedTab01, setSelectedTab01] = useState(1);
  const [selectedTab1, setSelectedTab1] = useState(1);

  const handleTabChange = (tab) => {
    setSelectedTab(tab);
  };
  const handleTabChange01 = (tab) => {
    setSelectedTab01(tab);
  };
  const handleTabChange1 = (tab) => {
    setSelectedTab1(tab);
    emitDataFilter(tab);
  };

  const emitDataFilter = (selectedValue) => {
    bus.emit('dataFilter', selectedValue);
  };

  const dropdownRef = useRef(null);
  const dropdownRef2 = useRef(null);
  const dropdownRef3 = useRef(null);

  const handleClickInsideDropdown = (e) => {
    const dropdownRefs = [dropdownRef, dropdownRef2, dropdownRef3];

    // Check if the clicked element is part of any of the dropdown menus
    if (
      dropdownRefs.some((ref) => ref.current && ref.current.contains(e.target))
    ) {
      // Allow propagation for clicks inside any of the dropdown menus
      return;
    }

    // Prevent propagation for clicks outside the dropdown menu
    e.stopPropagation();
  };

  const handleClose = () => {
    setModalOpen(false);
    setSelectedProductIds([]);
    setSelectedState('');
  };

  const handleClose2 = () => {
    setModalOpen2(false);
    setSelectedProductIds([]);
    setSelectedState('');
  };
  const handleClose3 = () => {
    setModalOpen3(false);
    setSelectedProductIds([]);
    setSelectedState('');
  };

  const handleYearChange = (direction) => {
    if (direction === 'down') {
      setSelectedYear(selectedYear - 1);
    } else if (direction === 'up' && selectedYear < currentYear) {
      setSelectedYear(selectedYear + 1);
    }
  };

  const [chartOptions, setChartOptions] = useState({
    chart: {
      type: 'bar',
      toolbar: {
        show: true,
      },
    },
    legend: {
      position: 'top',
      horizontalAlign: 'right',
    },
    colors: ['#53138D', '#d792e5', '#D1E9FF'],
    plotOptions: {
      bar: {
        horizontal: false,
        columnWidth: '25%',
        borderRadius: 5,
        borderRadiusApplication: 'end',
      },
    },
    dataLabels: {
      enabled: false,
    },
    xaxis: {
      categories: [],
    },
    yaxis: {
      labels: {
        formatter: function (val) {
          const formatAmount = (amount) => {
            if (amount >= 1000000) {
              return '₦' + (amount / 1000000).toFixed(0) + 'm';
            } else if (amount >= 1000) {
              return '₦' + (amount / 1000).toFixed(0) + 'k';
            } else {
              return '₦' + amount;
            }
          };

          // Formatting the value using the formatAmount function
          const formattedValue = formatAmount(Number(val));

          return formattedValue;
        },
      },
    },
    fill: {
      opacity: 1,
    },
    tooltip: {
      y: {
        formatter: function (val) {
          return '₦ ' + Number(val).toLocaleString();
        },
      },
    },
  });
  const [chartSeries, setChartSeries] = useState([
    {
      name: 'Revenue',
      data: [],
    },
  ]);
  const [chartOptions1, setChartOptions1] = useState({
    chart: {
      type: 'bar',
      toolbar: {
        show: true,
      },
    },
    legend: {
      position: 'top',
      horizontalAlign: 'right',
    },
    colors: ['#1570EF', '#53B1FD', '#D1E9FF'],
    plotOptions: {
      bar: {
        horizontal: false,
        columnWidth: '20%',
        borderRadius: 5,
        borderRadiusApplication: 'end',
      },
    },
    dataLabels: {
      enabled: false,
    },
    xaxis: {
      categories: [],
    },
    yaxis: {
      labels: {
        formatter: function (val) {
          return Number(val).toLocaleString();
        },
      },
    },
    fill: {
      opacity: 1,
    },
    tooltip: {
      y: {
        formatter: function (val) {
          return Number(val).toLocaleString();
        },
      },
    },
  });
  const [chartSeries1, setChartSeries1] = useState([
    {
      name: 'Remaining Stock',
      data: [],
    },
    {
      name: 'Total Stock',
      data: [],
    },
  ]);
  const [chartSeries2, setChartSeries2] = useState([]);
  const [chartOptions2, setChartOptions2] = useState({
    chart: {
      type: 'pie',
      toolbar: {
        show: true,
      },
    },
    dataLabels: {
      enabled: false,
    },
    colors: ['#1570EF', '#53B1FD', '#D1E9FF'],
    plotOptions: {
      pie: {
        labels: {
          formatter: function (val, opts) {
            var value = chartSeries2[opts.index];
            return val + ' - ' + value;
          },
        },
        style: {
          padding: '40px',
          justifyContent: 'space-between',
        },
      },
    },

    fill: {
      opacity: 1,
    },
    tooltip: {
      y: {
        formatter: function (val) {
          return Number(val).toLocaleString();
        },
      },
    },
  });

  const [chartSeries02, setChartSeries02] = useState([]);
  const [chartOptions02, setChartOptions02] = useState({
    chart: {
      type: 'pie',
      toolbar: {
        show: true,
      },
    },
    dataLabels: {
      enabled: false,
    },
    colors: [
      '#85E13A',
      '#D444F1',
      '#16B364',
      '#06AED4',
      '#2E90FA',
      '#875BF7',
      '#F63D68',
      '#EAAA08',
    ],
    labels: [],
    plotOptions: {
      pie: {
        labels: {
          formatter: function (val, opts) {
            var value = chartSeries02[opts.index];
            return val + ' - ' + value;
          },
        },
        style: {
          padding: '40px',
          justifyContent: 'space-between',
        },
      },
    },

    fill: {
      opacity: 1,
    },
    tooltip: {
      y: {
        formatter: function (val) {
          return Number(val).toLocaleString();
        },
      },
    },
  });

  const [chartOptions3, setChartOptions3] = useState({
    chart: {
      type: 'bar',
      toolbar: {
        show: true,
      },
    },
    legend: {
      position: 'top',
      horizontalAlign: 'right',
    },
    dataLabels: {
      enabled: false,
    },
    colors: ['#1570EF', '#53B1FD', '#D1E9FF'],
    plotOptions: {
      bar: {
        horizontal: false,
        columnWidth: '20%',
        borderRadius: 5,
        borderRadiusApplication: 'end',
      },
    },
    xaxis: {
      categories: [],
    },
    yaxis: {
      labels: {
        formatter: function (val) {
          const formatAmount = (amount) => {
            if (amount >= 1000000) {
              return '₦' + (amount / 1000000).toFixed(0) + 'm';
            } else if (amount >= 1000) {
              return '₦' + (amount / 1000).toFixed(0) + 'k';
            } else {
              return '₦' + amount;
            }
          };

          // Formatting the value using the formatAmount function
          const formattedValue = formatAmount(Number(val));

          return formattedValue;
        },
      },
    },
    fill: {
      opacity: 1,
    },
    tooltip: {
      y: {
        formatter: function (val) {
          return '₦ ' + Number(val).toLocaleString();
        },
      },
    },
  });
  const [chartSeries3, setChartSeries3] = useState([
    {
      name: 'Buying Power',
      data: [],
    },
  ]);
  // ----------------------Product SKU--------------------
  const [chartOptions4, setChartOptions4] = useState({
    chart: {
      type: 'bar',
      toolbar: {
        show: true,
      },
    },
    legend: {
      position: 'top',
      horizontalAlign: 'right',
    },
    colors: ['#1570EF', '#53B1FD', '#D1E9FF'],
    plotOptions: {
      bar: {
        horizontal: false,
        columnWidth: '20%',
        borderRadius: 5,
        borderRadiusApplication: 'end',
      },
    },
    xaxis: {
      categories: [],
    },
    yaxis: {
      labels: {
        formatter: function (val) {
          return Number(val).toLocaleString();
        },
      },
    },
    fill: {
      opacity: 1,
    },
    tooltip: {
      y: {
        formatter: function (val) {
          return Number(val).toLocaleString();
        },
      },
    },
    dataLabels: {
      enabled: false,
    },
  });
  const [chartSeries4, setChartSeries4] = useState([
    {
      name: 'Total Sales',
      data: [],
    },
  ]);

  const [chartOptions5, setChartOptions5] = useState({
    chart: {
      type: 'bar',
      toolbar: {
        show: true,
      },
    },
    legend: {
      position: 'top',
      horizontalAlign: 'right',
    },
    colors: ['#1570EF', '#23aa2a', '#ff0000'],
    plotOptions: {
      bar: {
        horizontal: false,
        columnWidth: '20%',
        borderRadius: 5,
        borderRadiusApplication: 'end',
      },
    },
    xaxis: {
      categories: [],
    },
    yaxis: {
      labels: {
        formatter: function (val) {
          return Number(val).toLocaleString();
        },
      },
    },
    fill: {
      opacity: 1,
    },
    tooltip: {
      y: {
        formatter: function (val) {
          return Number(val).toLocaleString();
        },
      },
    },
    dataLabels: {
      enabled: false,
    },
  });
  const [chartSeries5, setChartSeries5] = useState([
    {
      name: 'Order',
      data: [900, 550, 800, 810, 810, 600, 400, 400],
    },
  ]);
  const [chartOptions6, setChartOptions6] = useState({
    chart: {
      type: 'bar',
      toolbar: {
        show: true,
      },
    },
    annotations: {
      xaxis: [],
    },
    legend: {
      position: 'top',
      horizontalAlign: 'right',
    },
    colors: ['#af3585', '#f5f2fe', '#D1E9FF'],
    plotOptions: {
      bar: {
        horizontal: false,
        columnWidth: '20%',
        borderRadius: 5,
        borderRadiusApplication: 'end',
      },
    },
    xaxis: {
      categories: [],
    },
    yaxis: {
      labels: {
        formatter: function (val) {
          return Number(val).toLocaleString();
        },
      },
    },
    fill: {
      opacity: 1,
    },
    tooltip: {
      y: {
        formatter: function (val) {
          return Number(val).toLocaleString();
        },
      },
    },
    dataLabels: {
      enabled: false,
    },
  });
  const [chartSeries6, setChartSeries6] = useState([
    {
      name: 'Order',
      data: [900, 550, 800, 810, 810, 600, 400, 400, 600, 400, 400],
    },
  ]);
  const [chartOptions7, setChartOptions7] = useState({
    chart: {
      type: 'bar',
      toolbar: {
        show: true,
      },
    },

    legend: {
      position: 'top',
      horizontalAlign: 'right',
    },
    colors: ['#af3585', '#f5f2fe', '#D1E9FF'],
    // annotations: {
    //   xaxis: [{
    //     x: 500,
    //     borderColor: '#00E396',

    //   }],
    //   yaxis: [{
    //     y: 'July',
    //     y2: 'September',

    //   }]
    // },
    plotOptions: {
      bar: {
        horizontal: true,
        rowWidth: '10%',
        borderRadius: 5,
        borderRadiusApplication: 'end',
      },
    },
    dataLabels: {
      enabled: false,
      maxWidth: '10px',
    },
    xaxis: {
      categories: [],
      labels: {
        formatter: function (val) {
          const formatAmount = (amount) => {
            if (amount >= 1000000) {
              return (amount / 1000000).toFixed(2) + 'm';
            } else if (amount >= 1000) {
              return (amount / 1000).toFixed(2) + 'k';
            } else {
              return amount;
            }
          };

          // Formatting the value using the formatAmount function
          const formattedValue = formatAmount(Number(val));

          return formattedValue;
        },
      },
    },
    grid: {
      xaxis: {
        lines: {
          show: false,
        },
      },
    },
    tooltip: {
      y: {
        formatter: function (val) {
          return Number(val).toLocaleString();
        },
      },
    },
    yaxis: {
      reversed: false,
      axisTicks: {
        show: true,
      },
    },
  });
  const [chartSeries7, setChartSeries7] = useState([
    {
      name: 'HPS',
      data: [],
    },
  ]);
  const [chartOptions8, setChartOptions8] = useState({
    chart: {
      type: 'line',
      toolbar: {
        show: true,
        tools: {
          zoom: false,
          zoomin: false,
          zoomout: false,
          pan: false,
          reset: false,
          customIcons: {
            download: {
              icon: 'custom-toolbar-icon',
            },
          },
        },
      },
    },
    legend: {
      position: 'top',
      horizontalAlign: 'right',
    },
    dataLabels: {
      enabled: false,
    },
    colors: ['#1570EF'],
    plotOptions: {
      bar: {
        horizontal: false,
        columnWidth: '20%',
        borderRadius: 5,
        borderRadiusApplication: 'end',
      },
    },
    xaxis: {
      categories: [],
    },
    yaxis: {
      labels: {
        formatter: function (val) {
          return Number(val).toLocaleString();
        },
      },
    },
    fill: {
      opacity: 1,
    },
    tooltip: {
      y: {
        formatter: function (val) {
          return Number(val).toLocaleString();
        },
      },
    },
    dataLabels: {
      enabled: false,
    },
  });
  const [chartSeries8, setChartSeries8] = useState([]);
  const [chartOptions9, setChartOptions9] = useState({
    chart: {
      type: 'line',
      toolbar: {
        show: false,
      },
    },
    legend: {
      position: 'top',
      horizontalAlign: 'right',
    },
    // colors : ['#1570EF', '#53B1FD', '#D1E9FF'],
    plotOptions: {
      bar: {
        horizontal: false,
        columnWidth: '20%',
        borderRadius: 5,
        borderRadiusApplication: 'end',
      },
    },
    xaxis: {
      categories: [
        'Nigeria',
        'Ghana',
        'South Africa',
        'Egypt',
        'Benin',
        'Liberia',
        'Togo',
        'Sierrelone',
        'Senegal',
      ],
    },
    yaxis: {
      labels: {
        formatter: function (val, index) {
          return '₦' + val;
        },
      },
    },

    fill: {
      opacity: 1,
    },
    tooltip: {
      y: {
        formatter: function (val) {
          return '$ ' + val;
        },
      },
    },
  });
  const [chartSeries9, setChartSeries9] = useState([
    {
      name: 'Buying Power',
      data: [920, 550, 800, 1000, 810, 600, 400, 400],
    },
  ]);

  const handleStatFilter1 = () => {
    setStatFilter1(!statFilter1);
  };

  const handleStatFilter01 = () => {
    setStatFilter01(!statFilter01);
  };

  const handleSelectAllProductCategories = () => {
    setSelectAllProductCategory(!selectAllProductCategory);
    const selectedIds = productCatData?.map((option) => option._id);
    setSelectedProductCatIds(selectAllProductCategory ? [] : selectedIds);
  };

  const handleSearchCategory = (e) => {
    setSearchCategory(e.target.value);
  };

  const handleSearchState3 = (e) => {
    setSearchStates3(e.target.value);
  };

  const handleStateChange3 = (val) => {
    setSelectedState3(val);
  };

  const handleOpenModal1 = (val) => {
    setStatFilter1(!statFilter1);
    setModalVal1(val);
  };

  const handleProceedProductSalesChartFilter = () => {
    if (modalVal === 'hpl') {
      fetchHighestPerformingStoreStat();
    } else if (modalVal === 'p_s') {
      fetchProductSalesStat();
    } else {
      fetchPurchasedProductStat();
    }
    handleStatFilter1();
  };

  const handleProceedOBLFilter = () => {
    handleStatFilter01();
    fetchOBLStat();
  };

  const handleFetchProductCategories = () => {
    console.log(data);
    setIsProductCatPending(true);
    axiosInstance
      .get(`/admin/data-insights/brand-categoriesWithProduct/${data._id}`, {
        params: {
          search: searchProducts ? searchProducts : null,
        },
      })
      .then((res) => {
        setProductCatData(res.data.data);
        setIsProductCatPending(false);
      })
      .catch((err) => {
        try {
          notifyError(err.response.data.message);
        } catch {
          notifyError('Unable to fetch products!');
        }
      })
      .finally(() => setIsProductCatPending(false));
  };

  const fetchRevGrowthStat = (dateFilter) => {
    setIsRevGrowthPending(true);

    axiosInstance
      .get(
        `/admin/data-insights/brand-revenue-growth/${data._id}?dateFilter=${dateFilter}`
      )
      .then((res) => {
        const data = [
          {
            name: 'Revenue',
            data: res?.data?.data?.map((el) => `${el?.totalAmount}`),
          },
        ];

        setChartSeries((prev) => {
          return data;
        });

        setChartOptions((prev) => {
          return {
            ...prev,
            xaxis: {
              categories: res?.data?.data?.length
                ? res?.data?.data?.map((el) =>
                    el.type && el.type === 'week'
                      ? `Week ${parseInt(el.date, 10) + 1}`
                      : el.type && el.type === 'month'
                      ? el?.date
                      : el.type && el.type === 'hour'
                      ? moment(el?.date).format('h A')
                      : moment(el.date).format('YYYY-MM-DD')
                  )
                : [''],
            },
          };
        });
      })
      .catch((err) => {
        try {
          notifyError(err.response.data.message);
        } catch (error) {}
      })
      .finally(() => setIsRevGrowthPending(false));
  };

  const getRandomColor = () => {
    const letters = '0123456789ABCDEF';
    let color = '#';
    for (let i = 0; i < 6; i++) {
      color += letters[Math.floor(Math.random() * 16)];
    }
    return color;
  };

  const randomColors = Array.from({ length: 8 }, () => getRandomColor());

  const fetchDepletionStat = () => {
    setIsDepStatPending(true);
    axiosInstance
      .get(`/brand/data-insight/depletion`, {
        params: {
          dateFilter: dataFilter,
          products: selectedCategoryIds ? selectedCategoryIds : null,
          location: selectedState ? selectedState : null,
          categories: selectedProductCatIds ? selectedProductCatIds : null,
        },
      })
      .then((res) => {
        const data = [
          {
            name: 'Remaining Stock',
            data: res?.data?.data?.map((el) => el?.remainingStock),
          },
          {
            name: 'Total Stock',
            data: res?.data?.data?.map((el) => el?.totalPushed),
          },
        ];

        setChartSeries1((prev) => {
          return data;
        });
        setChartOptions1((prev) => {
          return {
            ...prev,
            xaxis: {
              categories: res?.data?.data?.length
                ? res?.data?.data?.map((el) => `${el?.product_name}`)
                : [''],
            },
          };
        });
        setSelectedProductCatIds([]);
        setSelectedCategoryIds([]);
        // setSelectedBrandIds([]);
        setSelectedState3('');
        setSearchStates3('');
        setCategorySelectedIds([]);
        setSelectAllStates(false);
        setSelectAllProductCategory(false);
      })
      .catch((err) => {
        try {
          notifyError(err.response.data.message);
        } catch (error) {}
      })
      .finally(() => setIsDepStatPending(false));
  };

  const fetchHighestLocationStat = () => {
    setIsProductSalesPending(true);
    axiosInstance
      .get(`/brand/data-insight/highest-performing-location`, {
        params: {
          dateFilter: dataFilter,
          products: selectedCategoryIds ? selectedCategoryIds : null,
          categories: selectedProductCatIds ? selectedProductCatIds : null,
        },
      })
      .then((res) => {
        const data = [
          {
            name: 'Total Orders',
            data: res?.data?.data?.map((el) => el?.totalSale),
          },
        ];

        setChartSeries6((prev) => {
          return data;
        });
        setChartOptions6((prev) => {
          return {
            ...prev,
            xaxis: {
              categories: res?.data?.data?.length
                ? res?.data?.data?.map((el) => `${el?._id}`)
                : [''],
            },
            annotations: {
              xaxis: res.data.data?.map((item) => ({
                x: item?._id,
                borderColor: '#af3585',
                background: '#af3585',
                border: 'none',
                marginBottom: '20px',
                label: {
                  borderColor: '#af3585',
                  orientation: 'horizontal',
                  text: `Total Store: ${item?.totalStore}`,
                  offsetY: -20,
                  style: {
                    background: '#af3585',
                    color: '#ffffff',
                    borderRadius: '10px',
                  },
                },
              })),
            },
          };
        });
        setSelectedProductCatIds([]);
        setSelectedCategoryIds([]);
        setSelectedState3('');
        setSearchStates3('');
        setSelectAllStates(false);
        setSelectAllProductCategory(false);
      })
      .catch((err) => {
        try {
          notifyError(err.response.data.message);
        } catch (error) {}
      })
      .finally(() => setIsProductSalesPending(false));
  };

  const fetchPurchasedProductStat = () => {
    setIsPurchasedProductPending(true);
    axiosInstance
      .get(`/brand/data-insight/product-sales-sku`, {
        params: {
          dateFilter: dataFilter,
          products: selectedCategoryIds ? selectedCategoryIds : null,
          location: selectedState3 ? selectedState3 : null,
          categories: selectedProductCatIds ? selectedProductCatIds : null,
        },
      })
      .then((res) => {
        const data = [
          {
            name: 'Brand SKU',
            data: res?.data?.data?.map((el) => el?.totalSale),
          },
        ];

        setChartSeries4((prev) => {
          return data;
        });
        setChartOptions4((prev) => {
          return {
            ...prev,
            xaxis: {
              categories: res?.data?.data?.length
                ? res?.data?.data?.map((el) => {
                    const productNameWords = el?.product_name.split(' ');
                    const specWords = el?.spec.split(' ');

                    const productNameFormatted = productNameWords.join('\n');
                    const specFormatted = specWords.join('\n');

                    return `${productNameFormatted}\n(${specFormatted})`;
                  })
                : [''],
            },
          };
        });
        setModalVal1('');
        setSelectedProductIds([]);
        setSelectedState3('');
        setSelectAllProductCategory(false);
      })
      .catch((err) => {
        try {
          notifyError(err.response.data.message);
        } catch (error) {}
      })
      .finally(() => setIsPurchasedProductPending(false));
  };

  const fetchProductSalesStat = () => {
    setIsProductSalesPending(true);
    axiosInstance
      .get(`/brand/data-insight/product-sales`, {
        params: {
          dateFilter: dataFilter,
          products: selectedCategoryIds ? selectedCategoryIds : null,
          location: selectedState3 ? selectedState3 : null,
          categories: selectedProductCatIds ? selectedProductCatIds : null,
        },
      })
      .then((res) => {
        const data = [
          {
            name: 'Product Sales',
            data: res?.data?.data?.map((el) => el?.totalSale),
          },
        ];

        setChartSeries5((prev) => {
          return data;
        });
        setChartOptions5((prev) => {
          return {
            ...prev,
            xaxis: {
              categories: res?.data?.data?.length
                ? res?.data?.data?.map((el) => `${el?.product_name}`)
                : [''],
            },
          };
        });
        setSelectedProductCatIds([]);
        setSelectedCategoryIds([]);
        setSelectedState3('');
        setSearchStates3('');
        setModalVal1('');
      })
      .catch((err) => {
        try {
          notifyError(err.response.data.message);
        } catch (error) {}
      })
      .finally(() => setIsProductSalesPending(false));
  };

  const fetchHighestPerformingStoreStat = () => {
    setIsHighestPerformingStorePending(true);
    axiosInstance
      .get(`/brand/data-insight/highest-performing-store`, {
        params: {
          dateFilter: dataFilter,
          products: selectedCategoryIds ? selectedCategoryIds : null,
          location: selectedState3 ? selectedState3 : null,
          categories: selectedProductCatIds ? selectedProductCatIds : null,
        },
      })
      .then((res) => {
        const data = [
          {
            name: 'HPS',
            data: res?.data?.data?.map((el) => el?.totalAmount),
          },
        ];

        setChartSeries7((prev) => {
          return data;
        });
        setChartOptions7((prev) => {
          return {
            ...prev,
            xaxis: {
              categories: res?.data?.data?.length
                ? res?.data?.data?.map((el) => `${el?.store_name}`)
                : [''],
            },
          };
        });
        setSelectedProductCatIds([]);
        setSelectedCategoryIds([]);
        setSelectedState3('');
        setSearchStates3('');
        setModalVal1('');
      })
      .catch((err) => {
        try {
          notifyError(err.response.data.message);
        } catch (error) {}
      })
      .finally(() => setIsHighestPerformingStorePending(false));
  };

  const fetchTrendsOfPurchase = () => {
    setIsTrendsOfPurchasePending(true);
    axiosInstance
      .get(`/brand/data-insight/trendsOfPurchase`, {
        params: {
          dateFilter: dataFilter,
          products: selectedProductIds ? selectedProductIds : null,
        },
      })
      .then((res) => {
        const uniqueProductNames = Array.from(
          new Set(
            res?.data?.data?.flatMap((item) =>
              item?.products?.map((product) => product?.product_name)
            )
          )
        );

        const data = uniqueProductNames?.map((productName) => {
          const productData = res?.data?.data?.map((item) => {
            const product = item?.products?.find(
              (p) => p?.product_name === productName
            );
            return product ? product?.totalProducts : 0;
          });

          return {
            name: productName,
            data: productData,
          };
        });

        setChartSeries8((prev) => {
          return data;
        });
        setChartOptions8((prev) => {
          return {
            ...prev,
            colors: randomColors,
            xaxis: {
              categories: res?.data?.data?.length
                ? res?.data?.data?.map((el) =>
                    el?.type && el?.type === 'week'
                      ? `Week ${parseInt(el?.date, 10) + 1}`
                      : el?.type && el?.type === 'month'
                      ? el?.date
                      : el?.type && el?.type === 'hour'
                      ? moment(el?.date).format('h A')
                      : moment(el?.date).format('YYYY-MM-DD')
                  )
                : [''],
            },
          };
        });
        setSelectedProductIds([]);
        setSelectedState('');
        setSelectAllProduct(false);
      })
      .catch((err) => {
        try {
          notifyError(err.response.data.message);
        } catch (error) {}
      })
      .finally(() => setIsTrendsOfPurchasePending(false));
  };

  const fetchMarketShareChart = () => {
    setIsMarketSharePending(true);
    axiosInstance
      .get(`/brand/data-insight/market-share`, {
        params: {
          dateFilter: dataFilter,
          category: selectedProductCatIds ? selectedProductCatIds : null,
        },
      })
      .then((res) => {
        const data = res?.data?.data?.length
          ? res?.data?.data?.map((el) => el?.totalProducts)
          : [''];

        setChartSeries2((prev) => {
          return data;
        });
        setChartOptions2((prev) => {
          return {
            ...prev,
            labels: res?.data?.data?.length
              ? res?.data?.data?.map(
                  (el) => `${el?.product_name} (${el?.percentage}%)`
                )
              : ['No Record Found'],
            colors: randomColors,
          };
        });
        setSelectedProductCatIds([]);
      })
      .catch((err) => {
        try {
          notifyError(err.response.data.message);
        } catch (error) {}
      })
      .finally(() => setIsMarketSharePending(false));
  };

  const fetchOBLStat = () => {
    setIsOBLPending(true);
    axiosInstance
      .get(`/brand/data-insight/heat-map`, {
        params: {
          dateFilter: dataFilter,
          products: selectedCategoryIds ? selectedCategoryIds : null,
          location: selectedState3 ? selectedState3 : null,
          categories: selectedProductCatIds ? selectedProductCatIds : null,
        },
      })
      .then((res) => {
        setMapData(res.data.data);
        setSelectedProductCatIds([]);
        setSelectedCategoryIds([]);
        setSelectedState3([]);
        setSelectAllStates([]);
        setSearchStates3('');
      })
      .catch((err) => {
        try {
          notifyError(err.response.data.message);
        } catch (error) {}
      })
      .finally(() => setIsOBLPending(false));
  };

  useEffect(() => {
    handleFetchProductCategories();
    fetchDepletionStat();
    fetchPurchasedProductStat();
    fetchProductSalesStat();
    fetchHighestLocationStat();
    fetchHighestPerformingStoreStat();
    fetchTrendsOfPurchase();
    fetchMarketShareChart();
    fetchOBLStat();
  }, [dataFilter]);

  useEffect(() => {
    bus.on('dataFilter', (el) => {
      setDataFilter(el);
    });

    bus.on('filterList', () => {
      setModalOpen(!modalOpen);
    });
  }, []);

  function handleClick(event) {
    event.preventDefault();
    navigate(-1);
  }

  const handleFetchStates = () => {
    setLoadingState(true);
    axiosInstance
      .get(`/brand/data-insight/product-location`, {
        params: {
          search: searchStates3,
        },
      })
      .then((res) => {
        setStates(res.data.data);
      })
      .finally(() => setLoadingState(false));
  };

  useEffect(() => {
    handleFetchStates();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [searchStates3]);

  useEffect(() => {
    // fetchStates();
    // handleFetchStates()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [country, state, searchStates, searchStates2, searchStates3]);

  const handleSearchProduct = (e) => {
    setSearchProducts(e.target.value);
  };

  const handleSearchState = (e) => {
    setSearchStates(e.target.value);
  };

  const handleSelectAllProduct = () => {
    setSelectAllProduct(!selectAllProduct);
    const selectedIds = productData?.map((option) => option._id);
    setSelectedProductIds(selectAllProduct ? [] : selectedIds);
  };

  const handleSelectAllStates = () => {
    setSelectAllStates(!selectAllStates);
    const selectedStates = states?.map((option) => option);
    setSelectedState(selectAllStates ? [] : selectedStates);
  };

  const handleCheckboxChange = (id) => {
    if (selectedProductIds.includes(id)) {
      setSelectedProductIds(
        selectedProductIds.filter((checkboxId) => checkboxId !== id)
      );
    } else {
      setSelectedProductIds([...selectedProductIds, id]);
    }
  };

  const handleCheckboxChange2 = (id) => {
    setSelectedProductIds([id]);
  };

  const handleProductCatCheckBoxChange = (id) => {
    if (selectedProductCatIds.includes(id)) {
      setSelectedProductCatIds(
        selectedProductCatIds.filter((checkboxId) => checkboxId !== id)
      );
    } else {
      setSelectedProductCatIds([...selectedProductCatIds, id]);
    }
  };

  const handleProductCatCheckBoxChange1 = (id) => {
    setSelectedProductCatIds([id]);
  };

  const handleProductCatCheckBoxChange2 = (id) => {
    setSelectedProductCatIds(id);
  };

  const handleCategoryBoxChange = (id) => {
    if (selectedCategoryIds.includes(id)) {
      setSelectedCategoryIds(
        selectedCategoryIds.filter((checkboxId) => checkboxId !== id)
      );
    } else {
      setSelectedCategoryIds([...selectedCategoryIds, id]);
    }
  };

  const handleStateChange = (val) => {
    setSelectedState(val);
    // if (selectedState.includes(val)) {
    //   setSelectedState(selectedState.filter((checkbox) => checkbox !== val));
    // } else {
    //   setSelectedState([...selectedState, val]);
    // }
  };

  const handleStateChange2 = (val) => {
    if (selectedState.includes(val)) {
      setSelectedState(selectedState.filter((checkbox) => checkbox !== val));
    } else {
      setSelectedState([...selectedState, val]);
    }
  };

  const handleFetchCategoryProducts = (id) => {
    setIsCategoryPending(true);
    setCategoryProductId(id);
    axiosInstance
      .get(`/admin/product/in-category/${id}`, {
        params: {
          search: searchCategory ? searchCategory : null,
        },
      })
      .then((res) => {
        setCatProductData(res?.data?.data[0]?.products);
        setIsCategoryPending(false);
      })
      .finally(() => setIsCategoryPending(false));
  };

  useEffect(() => {
    handleFetchCategoryProducts(categoryProductId);
  }, [searchCategory]);

  const handleFetchProduct = () => {
    setIsProductPending(true);
    axiosInstance
      .get(`/admin/product`, {
        params: {
          search: searchProducts,
        },
      })
      .then((res) => {
        setProductData(res?.data?.data);
        setIsProductPending(false);
      })
      .catch((err) => {
        try {
          notifyError(err.response.data.message);
        } catch {
          // notifyError('Unable to fetch product!')
        }
      })
      .finally(() => setIsProductPending(false));
  };

  useEffect(() => {
    handleFetchProduct();
    handleFetchProductCategories();
  }, [searchProducts]);

  const handleProceedFilter = () => {
    setModalOpen(!modalOpen);
    fetchProductSalesStat();
  };

  const handleProceedFilter2 = () => {
    setModalOpen2(!modalOpen2);
    fetchPurchasedProductStat();
  };

  const handleProceedFilter3 = () => {
    setModalOpen3(!modalOpen3);
    fetchDepletionStat();
  };

  const handleHPLChartFilter = () => {
    fetchHighestLocationStat();
  };

  const handleMSChartFilter = () => {
    fetchMarketShareChart();
  };

  const handleTOPChartFilter = () => {
    fetchTrendsOfPurchase();
  };

  const initialSelectedChartData = allChartData.map((item) => item.value);

  const [openEnableFilterModal, setOpenEnableFilterModal] = useState(false);
  const [selectedChartData, setSelectedChartData] = useState(
    initialSelectedChartData
  );

  const handleOpenEnableFilterModal = () => {
    setOpenEnableFilterModal(true);
  };

  const handleCloseEnableFilterModal = () => {
    setOpenEnableFilterModal(false);
  };

  const handleChartDataChange = (val) => {
    if (selectedChartData.includes(val)) {
      setSelectedChartData(
        selectedChartData.filter((checkboxVal) => checkboxVal !== val)
      );
    } else {
      setSelectedChartData([...selectedChartData, val]);
    }
  };

  return (
    <div style={{ marginTop: '7rem' }}>
      <div className="mt-md-5 mt-4 pt-2 px-2">
        <Filter2 width="100%" />

        <div className="d-flex mt-3 mb-3">
          <button
            className="btn btn-light ml-auto"
            type="button"
            onClick={handleOpenEnableFilterModal}
            style={{ border: '1px solid lightgrey', cursor: 'pointer' }}
          >
            <span>
              <img src="/assets/icons/trending-up.svg" alt="" /> &nbsp; View
              Charts
            </span>
          </button>

          {openEnableFilterModal && (
            <div
              className={`${styles.side_modal_overlay}`}
              onClick={handleCloseEnableFilterModal}
            >
              <div
                className={`${styles.side_modal_content}`}
                onClick={(e) => e.stopPropagation()}
              >
                {/* Your modal content goes here */}
                <div className="d-flex">
                  <h5>
                    <strong>Select Chart</strong>
                  </h5>
                  <span
                    onClick={handleCloseEnableFilterModal}
                    className="ml-auto"
                    style={{ cursor: 'pointer' }}
                  >
                    <img src="/assets/icons/x.svg" alt="" />
                  </span>
                </div>
                <p>
                  <small>Select Insight to display</small>
                </p>

                {allChartData.map((el, i) => {
                  return (
                    <div className="p-2 d-md-flex" key={i}>
                      <div className="mr-3">
                        <input
                          type="checkbox"
                          checked={selectedChartData.includes(el.value)}
                          onChange={() => handleChartDataChange(el.value)}
                        />
                      </div>
                      <div className=" ">
                        <p
                          className="mb-0 text-left"
                          style={{ fontSize: '14px' }}
                        >
                          {el?.name}
                        </p>
                      </div>
                    </div>
                  );
                })}
              </div>
            </div>
          )}
        </div>

        {/* ------------Depletion Stats---------- */}

        {selectedChartData.includes('d_s') && (
          <Card
            style={{ marginBottom: '20px', borderRadius: '10px' }}
            className="p-0"
          >
            <CardContent>
              <div className={`${styles.insight_header} pl-md-5`}>
                <h5>Depletion Stats</h5>
                <div className="d-md-flex justify-content-between">
                  <p>
                    Compare your orders against the depletion rate of your
                    product
                  </p>
                </div>
                <div className="row mt-md-0 mt-4"></div>
                <div className="d-flex">
                  <div className="dropleft ml-auto">
                    <button
                      className="btn  border"
                      onClick={() => setModalOpen3(true)}
                      style={{
                        backgroundColor: '#fff',
                        border: '1px solid #D0D5DD',
                        boxShadow: '0px 1px 2px rgba(16, 24, 40, 0.05)',
                        borderRadius: '4px',
                      }}
                    >
                      <img
                        className=""
                        style={{ display: 'inline', width: '17px' }}
                        src="/assets/icons/filterlines.svg"
                        alt=""
                      />
                      &nbsp;
                      <small className="d-none d-md-inline-block">
                        Filters
                      </small>
                    </button>
                  </div>
                  &nbsp; &nbsp;
                </div>
              </div>
              <span className="ml-md-3" style={{ fontSize: '12px' }}>
                QUANTITY
              </span>
              {isDepStatPending && (
                <BallTriangle
                  height={35}
                  width={45}
                  radius={5}
                  color="#af3585"
                  ariaLabel="ball-triangle-loading"
                  wrapperClass={{}}
                  wrapperStyle=""
                  visible={true}
                />
              )}
              <ReactApexChart
                type="bar"
                series={chartSeries1}
                options={chartOptions1}
                height={500}
              />
            </CardContent>
          </Card>
        )}

        {/* ------------Highest Performing Location---------- */}
        {selectedChartData.includes('h_p_l') && (
          <Card
            style={{
              marginTop: '20px',
              marginBottom: '20px',
              borderRadius: '10px',
            }}
            className="p-0"
          >
            <CardContent>
              <div className={`${styles.insight_header} pl-md-5`}>
                <h5>Highest Performing Location</h5>
                <div className="d-md-flex justify-content-between">
                  <p>Monitor how your stores perform in different areas</p>
                </div>
                <div className="d-flex">
                  <div className="dropleft ml-auto">
                    <button
                      id="dropdownMenuButton"
                      data-toggle="dropdown"
                      aria-haspopup="true"
                      aria-expanded="false"
                      style={{ fontSize: '15px', cursor: 'pointer' }}
                      className="btn p-2 border"
                    >
                      <img
                        className=""
                        style={{ display: 'inline', width: '17px' }}
                        src="/assets/icons/filterlines.svg"
                        alt=""
                      />
                      &nbsp;
                      <small className="d-none d-md-inline-block">
                        Filters
                      </small>
                    </button>
                    <div
                      className={`${styles.product_dialog_two} dropdown-menu p-3`}
                      aria-labelledby="dropdownMenuButton"
                      ref={dropdownRef}
                      onClick={handleClickInsideDropdown}
                      style={{ maxHeight: '330px', overflowY: 'auto' }}
                    >
                      <div className="allprod_wrapper mt-m3">
                        <div className={`${styles.modal_header} d-flex`}>
                          <h6
                            className="modal-title mb-2"
                            id="exampleModalLabel"
                            style={{ fontWeight: 'bold' }}
                          >
                            Products
                          </h6>
                          <span
                            className="ml-auto"
                            style={{ cursor: 'pointer' }}
                          >
                            <img src="/assets/icons/x.svg" alt="" />
                          </span>
                        </div>
                        <div className={`${styles.modal_body} mt-1`}>
                          <div className="row my-0 py-0">
                            <div className="col-7 py-0 my-0">
                              <label htmlFor="allprod">
                                <input
                                  type="checkbox"
                                  checked={selectAllProductCategory}
                                  onChange={handleSelectAllProductCategories}
                                />
                                &nbsp;&nbsp;All Products
                              </label>
                            </div>
                            <div className="col-5 py-0 my-0">
                              <span
                                className={`${styles.span}`}
                                data-toggle="collapse"
                                data-target="#collapseExample001"
                                aria-expanded="false"
                                aria-controls="collapseExample"
                              >
                                <label>
                                  <input type="checkbox" name="" />
                                  <span onClick={(e) => e.stopPropagation()}>
                                    <svg
                                      xmlns="http://www.w3.org/2000/svg"
                                      width="16"
                                      height="16"
                                      fill="currentColor"
                                      class="bi bi-chevron-down"
                                      viewBox="0 0 16 16"
                                    >
                                      <path
                                        fill-rule="evenodd"
                                        d="M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z"
                                      />
                                    </svg>
                                    {/* <i className="bi bi-chevron-down"></i> */}
                                  </span>
                                </label>
                              </span>
                            </div>
                          </div>
                          <div className="collapse" id="collapseExample001">
                            <div
                              className="card card-body pl-0 pb-0"
                              style={{ border: 'none' }}
                            >
                              <p>
                                <input
                                  type="text"
                                  className="form-control"
                                  placeholder="Search..."
                                  name=""
                                  id=""
                                  onChange={handleSearchProduct}
                                  value={searchProducts}
                                />
                              </p>
                              {!isProductCatPending &&
                                productCatData?.length > 0 &&
                                productCatData?.slice(0, 5).map((el, i) => {
                                  const filteredProducts = el?.products?.filter(
                                    (product) =>
                                      product?.product_name
                                        ?.toLowerCase()
                                        .includes(searchCategory.toLowerCase())
                                  );
                                  return (
                                    <>
                                      <div className="p-2 d-md-flex" key={i}>
                                        <div className="mr-3 mt-1">
                                          <input
                                            type="checkbox"
                                            checked={selectedProductCatIds.includes(
                                              el?._id
                                            )}
                                            onChange={() =>
                                              handleProductCatCheckBoxChange(
                                                el?._id
                                              )
                                            }
                                          />
                                        </div>
                                        <Avatar
                                          className={`${styles.avatrr} mr-3 floadt-md-left`}
                                          alt={el?.category_name}
                                          src={el?.category_image}
                                        />
                                        <div className=" ">
                                          <p
                                            className="mb-0 text-left"
                                            style={{ fontSize: '14px' }}
                                          >
                                            <strong>{el?.category_name}</strong>
                                          </p>
                                          <p
                                            className="mb-0 text-left"
                                            style={{ fontSize: '10px' }}
                                          >
                                            {el?.number_of_product < 2
                                              ? el?.number_of_product +
                                                ' product'
                                              : el?.number_of_product +
                                                ' products'}
                                          </p>
                                        </div>
                                        <div>
                                          <span
                                            className={`${styles.span}`}
                                            data-toggle="collapse"
                                            data-target={`#collapseExample1${el?._id}`}
                                            aria-expanded="false"
                                            aria-controls={`collapseExample${el?._id}`}
                                            onClick={() =>
                                              handleFetchCategoryProducts(
                                                el?._id
                                              )
                                            }
                                          >
                                            <label>
                                              <input type="checkbox" name="" />
                                              <span
                                                onClick={(e) =>
                                                  e.stopPropagation()
                                                }
                                              >
                                                <svg
                                                  xmlns="http://www.w3.org/2000/svg"
                                                  width="16"
                                                  height="16"
                                                  fill="currentColor"
                                                  class="bi bi-chevron-down"
                                                  viewBox="0 0 16 16"
                                                >
                                                  <path
                                                    fill-rule="evenodd"
                                                    d="M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z"
                                                  />
                                                </svg>
                                              </span>
                                            </label>
                                          </span>
                                        </div>
                                      </div>
                                      <div
                                        className="collapse"
                                        id={`collapseExample1${el?._id}`}
                                      >
                                        <div
                                          className="card card-body pl-5 pb-0"
                                          style={{ border: 'none' }}
                                        >
                                          <p>
                                            <input
                                              type="text"
                                              className="form-control"
                                              placeholder="Search..."
                                              name=""
                                              id=""
                                              onChange={handleSearchCategory}
                                              value={searchCategory}
                                            />
                                          </p>
                                          {!isCategoryPending &&
                                            filteredProducts?.length > 0 &&
                                            filteredProducts
                                              ?.slice(0, 5)
                                              .map((el, i) => {
                                                return (
                                                  <div
                                                    className="p-2 d-md-flex"
                                                    key={i}
                                                  >
                                                    <div className="mr-3 mt-1">
                                                      <input
                                                        type="checkbox"
                                                        checked={selectedCategoryIds.includes(
                                                          el?._id
                                                        )}
                                                        onChange={() =>
                                                          handleCategoryBoxChange(
                                                            el?._id
                                                          )
                                                        }
                                                      />
                                                    </div>
                                                    <div className=" ">
                                                      <p
                                                        className="mb-0 text-left"
                                                        style={{
                                                          fontSize: '14px',
                                                        }}
                                                      >
                                                        <strong>
                                                          {el?.product_name}
                                                        </strong>
                                                      </p>
                                                    </div>
                                                  </div>
                                                );
                                              })}
                                          {!isCategoryPending &&
                                            filteredProducts?.length < 1 && (
                                              <p>
                                                <i>No Record Found...</i>
                                              </p>
                                            )}
                                          <div className="d-flex justify-content-center">
                                            {isCategoryPending && (
                                              <BallTriangle
                                                height={30}
                                                width={35}
                                                radius={5}
                                                color="#af3585"
                                                ariaLabel="ball-triangle-loading"
                                                wrapperClass={{}}
                                                wrapperStyle=""
                                                visible={true}
                                              />
                                            )}
                                          </div>
                                        </div>
                                      </div>
                                    </>
                                  );
                                })}
                              {!isProductCatPending &&
                                productCatData?.length < 1 && (
                                  <p>
                                    <i>No Records Found...</i>
                                  </p>
                                )}
                              <div className="d-flex justify-content-center">
                                {isProductCatPending && (
                                  <BallTriangle
                                    height={50}
                                    width={55}
                                    radius={5}
                                    color="#af3585"
                                    ariaLabel="ball-triangle-loading"
                                    wrapperClass={{}}
                                    wrapperStyle=""
                                    visible={true}
                                  />
                                )}
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="mt-5">
                          <button
                            className={`${styles.btn_primary} btn w-100 d-block`}
                            data-dismiss="modal"
                            aria-label="Close"
                            type="button"
                            onClick={() => handleHPLChartFilter()}
                          >
                            Proceed
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                  &nbsp; &nbsp;
                </div>
              </div>
              <span className="ml-md-3" style={{ fontSize: '12px' }}>
                ORDERS
              </span>
              {isProductSalesPending && (
                <BallTriangle
                  height={50}
                  width={55}
                  radius={5}
                  color="#af3585"
                  ariaLabel="ball-triangle-loading"
                  wrapperClass={{}}
                  wrapperStyle=""
                  visible={true}
                />
              )}
              <div className="chart-container">
                <ReactApexChart
                  type="bar"
                  series={chartSeries6}
                  options={chartOptions6}
                  height={500}
                />
              </div>
            </CardContent>
          </Card>
        )}

        {/* ------------Purchased Product By SKU Variations---------- */}

        {selectedChartData.includes('p_p_b_s_v') && (
          <Card
            style={{
              marginTop: '20px',
              marginBottom: '20px',
              borderRadius: '10px',
            }}
            className="p-0"
          >
            <CardContent>
              <div className={`${styles.insight_header} pl-md-5`}>
                <h5>Purchased Product By SKU Variations</h5>
                <div className="d-md-flex justify-content-between">
                  <p>View the total sales of your individual products</p>
                </div>
                <div className="d-flex">
                  <div className="dropleft ml-auto">
                    <button
                      className="btn  border"
                      onClick={() => handleOpenModal1('sku')}
                      style={{
                        backgroundColor: '#fff',
                        border: '1px solid #D0D5DD',
                        boxShadow: '0px 1px 2px rgba(16, 24, 40, 0.05)',
                        borderRadius: '4px',
                      }}
                    >
                      <img
                        className=""
                        style={{ display: 'inline', width: '17px' }}
                        src="/assets/icons/filterlines.svg"
                        alt=""
                      />
                      &nbsp;
                      <small className="d-none d-md-inline-block">
                        Filters
                      </small>
                    </button>
                  </div>
                  &nbsp; &nbsp;
                </div>
              </div>
              <span className="ml-md-3" style={{ fontSize: '12px' }}>
                QUANTITY
              </span>
              <div className="chart-container">
                <ReactApexChart
                  type="bar"
                  series={chartSeries4}
                  options={chartOptions4}
                  height={500}
                />
              </div>
            </CardContent>
          </Card>
        )}

        {/* ------------Product Sales---------- */}

        {selectedChartData.includes('p_s') && (
          <Card
            style={{
              marginTop: '20px',
              marginBottom: '20px',
              borderRadius: '10px',
            }}
            className="p-0"
          >
            <CardContent>
              <div className={`${styles.insight_header} pl-md-5`}>
                <h5>Product Sales</h5>
                <div className="d-md-flex justify-content-between">
                  <p>View the total sales of your individual products</p>
                </div>
                <div className="d-flex">
                  <div className="dropleft ml-auto">
                    <button
                      className="btn  border"
                      onClick={() => handleOpenModal1('p_s')}
                      style={{
                        backgroundColor: '#fff',
                        border: '1px solid #D0D5DD',
                        boxShadow: '0px 1px 2px rgba(16, 24, 40, 0.05)',
                        borderRadius: '4px',
                      }}
                    >
                      <img
                        className=""
                        style={{ display: 'inline', width: '17px' }}
                        src="/assets/icons/filterlines.svg"
                        alt=""
                      />
                      &nbsp;
                      <small className="d-none d-md-inline-block">
                        Filters
                      </small>
                    </button>
                  </div>
                  &nbsp; &nbsp;
                </div>
              </div>
              <span className="ml-md-3" style={{ fontSize: '12px' }}>
                QUANTITY
              </span>
              {isProductSalesPending && (
                <BallTriangle
                  height={50}
                  width={55}
                  radius={5}
                  color="#af3585"
                  ariaLabel="ball-triangle-loading"
                  wrapperClass={{}}
                  wrapperStyle=""
                  visible={true}
                />
              )}
              <div className="chart-container">
                <ReactApexChart
                  type="bar"
                  series={chartSeries5}
                  options={chartOptions5}
                  height={500}
                />
              </div>
            </CardContent>
          </Card>
        )}

        {/* ------------Highest Performing Store---------- */}

        {selectedChartData.includes('h_p_s') && (
          <Card
            className={`${styles.card_wrapper} p-0`}
            style={{
              marginTop: '0px',
              marginBottom: '20px',
              borderRadius: '10px',
            }}
          >
            <CardContent>
              <div className={`${styles.insight_header}`}>
                <h5>Highest Performing Store</h5>
                <div className="d-lg-flex justify-content-between">
                  <p>See the stores that are performing best</p>
                </div>
                <div className="d-flex">
                  <div className="dropleft ml-auto">
                    <button
                      className="btn  border"
                      onClick={() => handleOpenModal1('hpl')}
                      style={{
                        backgroundColor: '#fff',
                        border: '1px solid #D0D5DD',
                        boxShadow: '0px 1px 2px rgba(16, 24, 40, 0.05)',
                        borderRadius: '4px',
                        width: '100px',
                        height: '40px',
                      }}
                    >
                      <img
                        className=""
                        style={{ display: 'inline', width: '28%' }}
                        src="/assets/icons/filterlines.svg"
                        alt=""
                      />
                      &nbsp;
                      <small className="d-none d-sm-inline-block">Filter</small>
                    </button>

                    <div
                      className="dropdown-menu drop-left"
                      aria-labelledby="dropdownMenuButton"
                    >
                      <button
                        type="button"
                        className=" dropdown-item btn border-0"
                        style={{ fontWeight: 'lighter' }}
                      >
                        All Brands{' '}
                      </button>
                      <button
                        type="button"
                        className=" dropdown-item btn border-0"
                      >
                        Brands you buy
                      </button>
                    </div>
                  </div>
                  &nbsp; &nbsp;
                </div>
              </div>
              {isHighestPerformingStorePending && (
                <BallTriangle
                  height={50}
                  width={55}
                  radius={5}
                  color="#af3585"
                  ariaLabel="ball-triangle-loading"
                  wrapperClass={{}}
                  wrapperStyle=""
                  visible={true}
                />
              )}
              <div className="chart-container">
                <ReactApexChart
                  type="bar"
                  series={chartSeries7}
                  options={chartOptions7}
                  height={500}
                />
              </div>
            </CardContent>
          </Card>
        )}

        {/* ------------Trends of Purchase---------- */}

        {selectedChartData.includes('t_o_p') && (
          <Card
            style={{ marginBottom: '20px', borderRadius: '10px' }}
            className="p-0"
          >
            <CardContent>
              <div className={`${styles.insight_header} pl-md-5`}>
                <h5>Trends of Purchase</h5>
                <div className="d-md-flex justify-content-between">
                  <p>View how well each products are doing in the market </p>
                </div>
                <div className="d-flex">
                  <div className="dropleft ml-auto">
                    <button
                      id="dropdownMenuButton2"
                      data-toggle="dropdown"
                      aria-haspopup="true"
                      aria-expanded="false"
                      // aria-expanded={statFilter2 ? 'true' : 'false'}
                      style={{ fontSize: '15px', cursor: 'pointer' }}
                      className="btn p-2 border"
                    >
                      <img
                        className=""
                        style={{ display: 'inline', width: '17px' }}
                        src="/assets/icons/filterlines.svg"
                        alt=""
                      />
                      &nbsp;
                      <small className="d-none d-md-inline-block">
                        Filters
                      </small>
                    </button>
                    <div
                      className={`${styles.product_dialog_three} dropdown-menu p-3`}
                      aria-labelledby="dropdownMenuButton2"
                      ref={dropdownRef2}
                      onClick={handleClickInsideDropdown}
                      style={{ maxHeight: '330px', overflowY: 'auto' }}
                    >
                      <div className="allprod_wrapper mt-m3">
                        <div className={`${styles.modal_header} d-flex`}>
                          <h6
                            className="modal-title mb-2"
                            id="exampleModalLabel"
                            style={{ fontWeight: 'bold' }}
                          >
                            Products
                          </h6>
                          <span
                            className="ml-auto"
                            style={{ cursor: 'pointer' }}
                          >
                            <img src="/assets/icons/x.svg" alt="" />
                          </span>
                        </div>
                        <div className={`${styles.modal_body}`}>
                          <div className="row my-0 py-0">
                            <div className="col-6 py-0 my-0">
                              <label htmlFor="allprod">
                                &nbsp;&nbsp;All Products
                              </label>
                            </div>
                            <div className="col-5 py-0 my-0">
                              <span
                                className={`${styles.span}`}
                                data-toggle="collapse"
                                data-target="#collapseExample11"
                                aria-expanded="false"
                                aria-controls="collapseExample"
                              >
                                <label>
                                  <input type="checkbox" name="" />
                                  <span onClick={(e) => e.stopPropagation()}>
                                    <svg
                                      xmlns="http://www.w3.org/2000/svg"
                                      width="16"
                                      height="16"
                                      fill="currentColor"
                                      class="bi bi-chevron-down"
                                      viewBox="0 0 16 16"
                                    >
                                      <path
                                        fill-rule="evenodd"
                                        d="M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z"
                                      />
                                    </svg>
                                    {/* <i className="bi bi-chevron-down"></i> */}
                                  </span>
                                </label>
                              </span>
                            </div>
                          </div>

                          <div className="collapse" id="collapseExample11">
                            <div
                              className="card card-body pl-1 pb-0"
                              style={{ border: 'none' }}
                            >
                              <p>
                                <input
                                  type="text"
                                  className="form-control"
                                  placeholder="Search..."
                                  name=""
                                  id=""
                                  onChange={handleSearchProduct}
                                  value={searchProducts}
                                />
                              </p>
                              {!isProductPending &&
                                productData.length > 0 &&
                                productData.slice(0, 5).map((el, i) => {
                                  return (
                                    <div className="p-2 d-md-flex" key={i}>
                                      <div className="mr-3 mt-1">
                                        <input
                                          type="radio"
                                          checked={selectedProductIds.includes(
                                            el._id
                                          )}
                                          onChange={() =>
                                            handleCheckboxChange2(el._id)
                                          }
                                        />
                                      </div>
                                      <Avatar
                                        className={`${styles.avatrr} mr-3 floadt-md-left`}
                                        alt={el?.product_name}
                                        src={el?.product_image}
                                      />
                                      <div className=" ">
                                        <p
                                          className="mb-0 text-left"
                                          style={{ fontSize: '14px' }}
                                        >
                                          <strong>{el?.product_name}</strong>
                                        </p>
                                        <p
                                          className="mb-0 text-left"
                                          style={{ fontSize: '10px' }}
                                        >
                                          {el?.product_spec}
                                        </p>
                                      </div>
                                    </div>
                                  );
                                })}
                              {!isProductPending && productData.length < 1 && (
                                <p>
                                  <i>No Records Found...</i>
                                </p>
                              )}
                              <div className="d-flex justify-content-center">
                                {isProductPending && (
                                  <BallTriangle
                                    height={50}
                                    width={55}
                                    radius={5}
                                    color="#af3585"
                                    ariaLabel="ball-triangle-loading"
                                    wrapperClass={{}}
                                    wrapperStyle=""
                                    visible={true}
                                  />
                                )}
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="mt-5">
                          <button
                            className={`${styles.btn_primary} btn w-100 d-block`}
                            data-dismiss="modal"
                            aria-label="Close"
                            type="button"
                            onClick={() => handleTOPChartFilter()}
                          >
                            Proceed
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                  &nbsp; &nbsp;
                </div>
              </div>
              <span className="ml-md-3" style={{ fontSize: '12px' }}>
                QUANTITY
              </span>
              {isTrendsOfPurchasePending && (
                <BallTriangle
                  height={50}
                  width={55}
                  radius={5}
                  color="#af3585"
                  ariaLabel="ball-triangle-loading"
                  wrapperClass={{}}
                  wrapperStyle=""
                  visible={true}
                />
              )}
              <div className="chart-container">
                <ReactApexChart
                  type="line"
                  series={chartSeries8}
                  options={chartOptions8}
                  height={500}
                />
              </div>
            </CardContent>
          </Card>
        )}

        {/* ------------Market Share---------- */}

        {selectedChartData.includes('m_s') && (
          <Card
            style={{ marginBottom: '20px', borderRadius: '10px' }}
            className="p-0"
          >
            <CardContent>
              <div className={`${styles.insight_header} pl-md-5`}>
                <h5>Market Share</h5>
                <div className="d-md-flex justify-content-between">
                  <p>A view of your product's market share</p>
                </div>
                <div className="d-flex">
                  <div className="dropleft ml-auto">
                    <button
                      id="dropdownMenuButton3"
                      data-toggle="dropdown"
                      aria-haspopup="true"
                      aria-expanded="false"
                      style={{ fontSize: '15px', cursor: 'pointer' }}
                      className="btn p-2 border"
                    >
                      <img
                        className=""
                        style={{ display: 'inline', width: '17px' }}
                        src="/assets/icons/filterlines.svg"
                        alt=""
                      />
                      &nbsp;
                      <small className="d-none d-md-inline-block">
                        Filters
                      </small>
                    </button>
                    <div
                      className={`${styles.product_dialog_three} dropdown-menu p-3`}
                      aria-labelledby="dropdownMenuButton3"
                      ref={dropdownRef3}
                      onClick={handleClickInsideDropdown}
                      style={{ maxHeight: '330px', overflowY: 'auto' }}
                    >
                      <div className="allprod_wrapper mt-m3">
                        <div className={`${styles.modal_header} d-flex`}>
                          <h6
                            className="modal-title mb-2"
                            id="exampleModalLabel"
                            style={{ fontWeight: 'bold' }}
                          >
                            Categories
                          </h6>
                          <span
                            className="ml-auto"
                            style={{ cursor: 'pointer' }}
                          >
                            <img src="/assets/icons/x.svg" alt="" />
                          </span>
                        </div>
                        <p className="ml-md-1">Select Categories</p>
                        <div className={`${styles.modal_body} mt-1`}>
                          <div
                            className="card card-body pl-1 pb-0"
                            style={{ border: 'none' }}
                          >
                            <p>
                              <input
                                type="text"
                                className="form-control"
                                placeholder="Search..."
                                name=""
                                id=""
                                onChange={handleSearchProduct}
                                value={searchProducts}
                              />
                            </p>
                            {!isProductCatPending &&
                              productCatData?.length > 0 &&
                              productCatData?.slice(0, 5).map((el, i) => {
                                const filteredProducts = el?.products?.filter(
                                  (product) =>
                                    product?.product_name
                                      ?.toLowerCase()
                                      .includes(searchCategory.toLowerCase())
                                );
                                return (
                                  <>
                                    <div className="p-2 pl-3 d-md-flex" key={i}>
                                      <div className="mr-3 mt-1">
                                        <input
                                          type="radio"
                                          checked={selectedProductCatIds.includes(
                                            el?._id
                                          )}
                                          onChange={() =>
                                            handleProductCatCheckBoxChange2(
                                              el?._id
                                            )
                                          }
                                        />
                                      </div>
                                      <Avatar
                                        className={`${styles.avatrr} mr-3 floadt-md-left`}
                                        alt={el?.category_name}
                                        src={el?.category_image}
                                      />
                                      <div className=" ">
                                        <p
                                          className="mb-0 text-left"
                                          style={{ fontSize: '14px' }}
                                        >
                                          <strong>{el?.category_name}</strong>
                                        </p>
                                        <p
                                          className="mb-0 text-left"
                                          style={{ fontSize: '10px' }}
                                        >
                                          {el?.number_of_product < 2
                                            ? el?.number_of_product + ' product'
                                            : el?.number_of_product +
                                              ' products'}
                                        </p>
                                      </div>
                                      <div></div>
                                    </div>
                                  </>
                                );
                              })}
                            {!isProductCatPending &&
                              productCatData?.length < 1 && (
                                <p>
                                  <i>No Records Found...</i>
                                </p>
                              )}
                            <div className="d-flex justify-content-center">
                              {isProductCatPending && (
                                <BallTriangle
                                  height={50}
                                  width={55}
                                  radius={5}
                                  color="#af3585"
                                  ariaLabel="ball-triangle-loading"
                                  wrapperClass={{}}
                                  wrapperStyle=""
                                  visible={true}
                                />
                              )}
                            </div>
                          </div>
                        </div>
                        <div className="mt-5">
                          <button
                            className={`${styles.btn_primary} btn w-100 d-block`}
                            data-dismiss="modal"
                            aria-label="Close"
                            type="button"
                            onClick={() => handleMSChartFilter()}
                          >
                            Proceed
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="row">
                  <div className="col-md-12">
                    <div className="chart-container">
                      {isMarketSharePending && (
                        <BallTriangle
                          height={50}
                          width={55}
                          radius={5}
                          color="#af3585"
                          ariaLabel="ball-triangle-loading"
                          wrapperClass={{}}
                          wrapperStyle=""
                          visible={true}
                        />
                      )}
                      <div className="container_adjust3">
                        <ReactApexChart
                          type="pie"
                          series={chartSeries2}
                          options={chartOptions2}
                          height={400}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </CardContent>
          </Card>
        )}

        {/* ------------Order By Location---------- */}

        {
          selectedChartData.includes('o_b_l') && (
            <Card
              className={`${styles.card_wrapper} p-0`}
              style={{ marginBottom: '20px', borderRadius: '10px' }}
            >
              <CardContent>
                <div className="row">
                  <div className="col-md-7">
                    <GoogleMapHeatmap data={mapData} />
                  </div>
                  <div className="col-md-4">
                    <div className={`${styles.insight_header} mt-5`}>
                      <h5>Order by Location</h5>
                      <div className="d-lg-flex justify-content-between">
                        <p>View how your order is doing on various location</p>
                      </div>
                      <div>
                        <div className="dropleft ">
                          <button
                            className="btn  border"
                            onClick={() => setStatFilter01(true)}
                            style={{
                              backgroundColor: '#fff',
                              border: '1px solid #D0D5DD',
                              boxShadow: '0px 1px 2px rgba(16, 24, 40, 0.05)',
                              borderRadius: '4px',
                            }}
                          >
                            <img
                              className=""
                              style={{ display: 'inline', width: '17px' }}
                              src="/assets/icons/filterlines.svg"
                              alt=""
                            />
                            &nbsp;
                            <small className="d-none d-md-inline-block">
                              Filters
                            </small>
                          </button>
                          <div
                            className="dropdown-menu drop-left"
                            aria-labelledby="dropdownMenuButton"
                          >
                            {/* <button type="button" className="rss dropdown-item btn border-0">All</button>
                          <button type="button"  className="rss dropdown-item btn border-0">Abandoned </button>
                          <button type="button"  className="rss dropdown-item btn border-0">Completed</button> */}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="mt-5">
                    <button
                      className="btn btn-primary w-100 d-block"
                      data-dismiss="modal"
                      aria-label="Close"
                    >
                      Proceed
                    </button>
                  </div>
                </div>
              </CardContent>
            </Card>
          )
          // </GlobalModal>
        }

        <GlobalModal
          open={modalOpen}
          onClose={handleClose}
          position="absolute"
          top="50%"
          left="50%"
          transform="translate(-50%, -50%)"
          width="740px !important"
          height="auto !important"
          maxHeight="500px !important"
          overflow="auto"
          bgcolor="#fff"
          border="1px solid #F5F5F5"
          borderRadius="5px"
          boxShadow="24"
          p="25px"
        >
          <div className={`${styles.modal_content}`}>
            <div className={`${styles.modal_header} mb-0`}>
              <h5
                style={{
                  fontSize: '19px',
                  fontWeight: '700',
                }}
              >
                {/* Filter */}
              </h5>
              <span
                onClick={handleClose}
                className="justify-content-end"
                style={{ cursor: 'pointer' }}
              >
                <img src="/assets/icons/x.svg" alt="" />
              </span>
            </div>
            <div className={`${styles.modal_content} row`}>
              <div className="col-md-6">
                <div className="allprod_wrapper">
                  <div className="modal-header" style={{ border: 'none' }}>
                    <h5 className="modal-title" id="exampleModalLabel">
                      Products
                    </h5>
                  </div>
                  <div className={`${styles.modal_body}`}>
                    <div className="row my-0 py-0">
                      <div className="col-7 py-0 my-0">
                        <label htmlFor="allprod">
                          <input
                            type="checkbox"
                            checked={selectAllProduct}
                            onChange={handleSelectAllProduct}
                          />
                          &nbsp;&nbsp;All Products
                        </label>
                      </div>
                      <div className="col-5 py-0 my-0">
                        <span
                          className={`${styles.span}`}
                          data-toggle="collapse"
                          data-target="#collapseExample01"
                          aria-expanded="false"
                          aria-controls="collapseExample"
                        >
                          <label>
                            <input type="checkbox" name="" />
                            <span>
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="16"
                                height="16"
                                fill="currentColor"
                                class="bi bi-chevron-down"
                                viewBox="0 0 16 16"
                              >
                                <path
                                  fill-rule="evenodd"
                                  d="M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z"
                                />
                              </svg>
                              {/* <i className="bi bi-chevron-down"></i> */}
                            </span>
                          </label>
                        </span>
                      </div>
                    </div>

                    <div className="collapse" id="collapseExample01">
                      <div
                        className="card card-body pl-5 pb-0"
                        style={{ border: 'none' }}
                      >
                        <p>
                          <input
                            type="text"
                            className="form-control"
                            placeholder="Search..."
                            name=""
                            id=""
                            onChange={handleSearchProduct}
                            value={searchProducts}
                          />
                        </p>
                        {!isProductPending &&
                          productData.length > 0 &&
                          productData.slice(0, 5).map((el, i) => {
                            return (
                              <div className="p-2 d-md-flex" key={i}>
                                <div className="mr-3 mt-1">
                                  <input
                                    type="checkbox"
                                    checked={selectedProductIds.includes(
                                      el._id
                                    )}
                                    onChange={() =>
                                      handleCheckboxChange(el._id)
                                    }
                                  />
                                </div>
                                <Avatar
                                  className={`${styles.avatrr} mr-3 floadt-md-left`}
                                  alt={el?.product_name}
                                  src={el?.product_image}
                                />
                                <div className=" ">
                                  <p
                                    className="mb-0 text-left"
                                    style={{ fontSize: '14px' }}
                                  >
                                    <strong>{el?.product_name}</strong>
                                  </p>
                                  <p
                                    className="mb-0 text-left"
                                    style={{ fontSize: '10px' }}
                                  >
                                    {el?.product_spec}
                                  </p>
                                </div>
                              </div>
                              // <div className="row" key={i}>
                              //   <p className="col-6">
                              //     <label htmlFor="milo1">
                              //       <div>
                              //         <input type="checkbox" name="milo1" id="milo1" />
                              //       </div>
                              //       <div>
                              //         <span>{el.product_name}</span>
                              //       </div>
                              //     </label>
                              //   </p>
                              // </div>
                            );
                          })}
                        {!isProductPending && productData.length < 1 && (
                          <p>
                            <i>No Records Found...</i>
                          </p>
                        )}
                        <div className="d-flex justify-content-center">
                          {isProductPending && (
                            <BallTriangle
                              height={50}
                              width={55}
                              radius={5}
                              color="#af3585"
                              ariaLabel="ball-triangle-loading"
                              wrapperClass={{}}
                              wrapperStyle=""
                              visible={true}
                            />
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div
                className={`${styles.bordered_sect} col-md-6`}
                style={{
                  borderLeft: '2px solid #ddd',
                }}
              >
                <div className="allprod_wrapper">
                  <div className="modal-header" style={{ border: 'none' }}>
                    <h5 className="modal-title" id="exampleModalLabel">
                      Location/Store
                    </h5>
                  </div>
                  <div className={`${styles.modal_body}`}>
                    <div className="row my-0 py-0">
                      <div className="col-5 py-0 my-0">
                        <label htmlFor="country">
                          {/* <input
                            type="checkbox"
                            checked={selectAllStates}
                            onChange={handleSelectAllStates}
                          />
                          &nbsp;&nbsp; */}
                          Nigeria
                        </label>
                      </div>
                      <div className="col-5 py-0 my-0">
                        <span
                          className={`${styles.span}`}
                          data-toggle="collapse"
                          data-target="#collapseExample02"
                          aria-expanded="false"
                          aria-controls="collapseExample"
                        >
                          <label>
                            <input type="checkbox" name="" />
                            <span>
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="16"
                                height="16"
                                fill="currentColor"
                                class="bi bi-chevron-down"
                                viewBox="0 0 16 16"
                              >
                                <path
                                  fill-rule="evenodd"
                                  d="M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z"
                                />
                              </svg>
                              {/* <i className="bi bi-chevron-down"></i> */}
                            </span>
                          </label>
                        </span>
                      </div>
                    </div>

                    <div className="collapse pl-1" id="collapseExample02">
                      <div
                        className="card card-body pl-5 pb-0"
                        style={{ border: 'none' }}
                      >
                        <p>
                          <input
                            type="text"
                            className="form-control"
                            placeholder="Search..."
                            name=""
                            id=""
                            onChange={handleSearchState}
                            value={searchStates}
                          />
                        </p>
                        <div className="row mt-3">
                          {!loadingState &&
                            states &&
                            states[0]?.states &&
                            states[0]?.states
                              .slice(0, 14)
                              .map((state, index) => {
                                const id = `state-${index}`;
                                return (
                                  <div
                                    className="col-6 py-0 my-0 d-md-flex"
                                    key={index}
                                  >
                                    <label htmlFor={id}>
                                      <input
                                        type="radio"
                                        id={id}
                                        className="mr-2"
                                        checked={selectedState.includes(state)}
                                        onChange={() =>
                                          handleStateChange(state)
                                        }
                                      />
                                    </label>
                                    <div>{state}</div>
                                  </div>
                                );
                              })}
                        </div>
                        {!loadingState && states.length < 1 && (
                          <p>
                            <i>No Records Found...</i>
                          </p>
                        )}
                        <div className="d-flex justify-content-center">
                          {loadingState && (
                            <BallTriangle
                              height={50}
                              width={55}
                              radius={5}
                              color="#af3585"
                              ariaLabel="ball-triangle-loading"
                              wrapperClass={{}}
                              wrapperStyle=""
                              visible={true}
                            />
                          )}
                        </div>

                        <div className="collapse pl-1" id="collapseExample03">
                          <div
                            className="card card-body pl-5 pb-0"
                            style={{ border: 'none' }}
                          >
                            <p>
                              <input
                                type="text"
                                className="form-control"
                                placeholder="Search..."
                                name=""
                                id=""
                              />
                            </p>
                            <p>
                              <label htmlFor="milo2">
                                <input
                                  type="checkbox"
                                  name="milo2"
                                  id="milo2"
                                />
                                &nbsp;&nbsp;<span>Mama tee superstore</span>
                              </label>
                            </p>
                            <p>
                              <label htmlFor="water2">
                                <input
                                  type="checkbox"
                                  name="water2"
                                  id="water2"
                                />
                                &nbsp;&nbsp;<span>Shoprite</span>
                              </label>
                            </p>
                            <p>
                              <label htmlFor="nescafe2">
                                <input
                                  type="checkbox"
                                  name="nescafe2"
                                  id="nescafe2"
                                />
                                &nbsp;&nbsp;<span>Justrite</span>
                              </label>
                            </p>
                            <p>
                              <label htmlFor="kitkat2">
                                <input
                                  type="checkbox"
                                  name="kitkat2"
                                  id="kitkat2"
                                />
                                &nbsp;&nbsp;<span>Mallmart</span>
                              </label>
                            </p>
                            <p>
                              <label htmlFor="maggi2">
                                <input
                                  type="checkbox"
                                  name="maggi2"
                                  id="maggi2"
                                />
                                &nbsp;&nbsp;<span>Jendol</span>
                              </label>
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="mt-5">
              <button
                className="btn btn-primary w-100 d-block"
                data-dismiss="modal"
                aria-label="Close"
              >
                Proceed
              </button>
            </div>
          </div>
        </GlobalModal>

        <GlobalModal
          open={modalOpen2}
          onClose={handleClose2}
          position="absolute"
          top="50%"
          left="50%"
          transform="translate(-50%, -50%)"
          width="740px !important"
          height="auto !important"
          maxHeight="500px !important"
          overflow="auto"
          bgcolor="#fff"
          border="1px solid #F5F5F5"
          borderRadius="5px"
          boxShadow="24"
          p="25px"
        >
          <div className={`${styles.modal_content}`}>
            <div className={`${styles.modal_header} mb-0`}>
              <h5
                style={{
                  fontSize: '19px',
                  fontWeight: '700',
                }}
              >
                {/* Filter */}
              </h5>
              <span
                onClick={handleClose2}
                className="justify-content-end"
                style={{ cursor: 'pointer' }}
              >
                <img src="/assets/icons/x.svg" alt="" />
              </span>
            </div>
            <div className={`${styles.modal_content} row`}>
              <div className="col-md-6">
                <div className="allprod_wrapper">
                  <div className="modal-header" style={{ border: 'none' }}>
                    <h5 className="modal-title" id="exampleModalLabel">
                      Products
                    </h5>
                  </div>
                  <div className={`${styles.modal_body}`}>
                    <div className="row my-0 py-0">
                      <div className="col-7 py-0 my-0">
                        <label htmlFor="allprod">
                          <input
                            type="checkbox"
                            checked={selectAllProduct}
                            onChange={handleSelectAllProduct}
                          />
                          &nbsp;&nbsp;All Products
                        </label>
                      </div>
                      <div className="col-5 py-0 my-0">
                        <span
                          className={`${styles.span}`}
                          data-toggle="collapse"
                          data-target="#collapseExample01"
                          aria-expanded="false"
                          aria-controls="collapseExample"
                        >
                          <label>
                            <input type="checkbox" name="" />
                            <span>
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="16"
                                height="16"
                                fill="currentColor"
                                class="bi bi-chevron-down"
                                viewBox="0 0 16 16"
                              >
                                <path
                                  fill-rule="evenodd"
                                  d="M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z"
                                />
                              </svg>
                              {/* <i className="bi bi-chevron-down"></i> */}
                            </span>
                          </label>
                        </span>
                      </div>
                    </div>

                    <div className="collapse" id="collapseExample01">
                      <div
                        className="card card-body pl-5 pb-0"
                        style={{ border: 'none' }}
                      >
                        <p>
                          <input
                            type="text"
                            className="form-control"
                            placeholder="Search..."
                            name=""
                            id=""
                            onChange={handleSearchProduct}
                            value={searchProducts}
                          />
                        </p>
                        {!isProductPending &&
                          productData.length > 0 &&
                          productData.slice(0, 5).map((el, i) => {
                            return (
                              <div className="p-2 d-md-flex" key={i}>
                                <div className="mr-3 mt-1">
                                  <input
                                    type="radio"
                                    checked={selectedProductIds.includes(
                                      el._id
                                    )}
                                    onChange={() =>
                                      handleCheckboxChange2(el._id)
                                    }
                                  />
                                </div>
                                <Avatar
                                  className={`${styles.avatrr} mr-3 floadt-md-left`}
                                  alt={el?.product_name}
                                  src={el?.product_image}
                                />
                                <div className=" ">
                                  <p
                                    className="mb-0 text-left"
                                    style={{ fontSize: '14px' }}
                                  >
                                    <strong>{el?.product_name}</strong>
                                  </p>
                                  <p
                                    className="mb-0 text-left"
                                    style={{ fontSize: '10px' }}
                                  >
                                    {el?.product_spec}
                                  </p>
                                </div>
                              </div>
                              // <div className="row" key={i}>
                              //   <p className="col-6">
                              //     <label htmlFor="milo1">
                              //       <div>
                              //         <input type="checkbox" name="milo1" id="milo1" />
                              //       </div>
                              //       <div>
                              //         <span>{el.product_name}</span>
                              //       </div>
                              //     </label>
                              //   </p>
                              // </div>
                            );
                          })}
                        {!isProductPending && productData.length < 1 && (
                          <p>
                            <i>No Records Found...</i>
                          </p>
                        )}
                        <div className="d-flex justify-content-center">
                          {isProductPending && (
                            <BallTriangle
                              height={50}
                              width={55}
                              radius={5}
                              color="#af3585"
                              ariaLabel="ball-triangle-loading"
                              wrapperClass={{}}
                              wrapperStyle=""
                              visible={true}
                            />
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div
                className={`${styles.bordered_sect} col-md-6`}
                style={{
                  borderLeft: '2px solid #ddd',
                }}
              >
                <div className="allprod_wrapper">
                  <div className="modal-header" style={{ border: 'none' }}>
                    <h5 className="modal-title" id="exampleModalLabel">
                      Location/Store
                    </h5>
                  </div>
                  <div className={`${styles.modal_body}`}>
                    <div className="row my-0 py-0">
                      <div className="col-5 py-0 my-0">
                        <label htmlFor="country">
                          <input
                            type="checkbox"
                            checked={selectAllStates}
                            onChange={handleSelectAllStates}
                          />
                          &nbsp;&nbsp; Nigeria
                        </label>
                      </div>
                      <div className="col-5 py-0 my-0">
                        <span
                          className={`${styles.span}`}
                          data-toggle="collapse"
                          data-target="#collapseExample02"
                          aria-expanded="false"
                          aria-controls="collapseExample"
                        >
                          <label>
                            <input type="checkbox" name="" />
                            <span>
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="16"
                                height="16"
                                fill="currentColor"
                                class="bi bi-chevron-down"
                                viewBox="0 0 16 16"
                              >
                                <path
                                  fill-rule="evenodd"
                                  d="M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z"
                                />
                              </svg>
                              {/* <i className="bi bi-chevron-down"></i> */}
                            </span>
                          </label>
                        </span>
                      </div>
                    </div>

                    <div className="collapse pl-1" id="collapseExample02">
                      <div
                        className="card card-body pl-5 pb-0"
                        style={{ border: 'none' }}
                      >
                        <p>
                          <input
                            type="text"
                            className="form-control"
                            placeholder="Search..."
                            name=""
                            id=""
                            onChange={handleSearchState}
                            value={searchStates}
                          />
                        </p>
                        <div className="row mt-3">
                          {!loadingState &&
                            states &&
                            states[0]?.states &&
                            states[0]?.states
                              .slice(0, 14)
                              .map((state, index) => {
                                const id = `state-${index}`;
                                return (
                                  <div
                                    className="col-6 py-0 my-0 d-md-flex"
                                    key={index}
                                  >
                                    <label htmlFor={id}>
                                      <input
                                        type="checkbox"
                                        id={id}
                                        className="mr-2"
                                        checked={selectedState.includes(state)}
                                        onChange={() =>
                                          handleStateChange2(state)
                                        }
                                      />
                                    </label>
                                    <div>{state}</div>
                                  </div>
                                );
                              })}
                        </div>
                        {!loadingState && states.length < 1 && (
                          <p>
                            <i>No Records Found...</i>
                          </p>
                        )}
                        <div className="d-flex justify-content-center">
                          {loadingState && (
                            <BallTriangle
                              height={50}
                              width={55}
                              radius={5}
                              color="#af3585"
                              ariaLabel="ball-triangle-loading"
                              wrapperClass={{}}
                              wrapperStyle=""
                              visible={true}
                            />
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="mt-5">
              <button
                className="btn btn-primary w-100 d-block"
                data-dismiss="modal"
                aria-label="Close"
              >
                Proceed
              </button>
            </div>
          </div>
        </GlobalModal>

        <GlobalModal
          open={modalOpen3}
          onClose={handleClose3}
          position="absolute"
          top="50%"
          left="50%"
          transform="translate(-50%, -50%)"
          width="740px !important"
          height="auto !important"
          maxHeight="500px !important"
          overflow="auto"
          bgcolor="#fff"
          border="1px solid #F5F5F5"
          borderRadius="5px"
          boxShadow="24"
          p="25px"
        >
          <div className={`${styles.modal_content}`}>
            <div className={`${styles.modal_header} mb-0`}>
              <h5
                style={{
                  fontSize: '19px',
                  fontWeight: '700',
                }}
              >
                {/* Filter */}
              </h5>
              <span
                onClick={handleClose3}
                className="justify-content-end"
                style={{ cursor: 'pointer' }}
              >
                <img src="/assets/icons/x.svg" alt="" />
              </span>
            </div>
            <div className={`${styles.modal_content} row`}>
              <div className="col-md-6">
                <div className="allprod_wrapper mt-m3">
                  <h6
                    className="modal-title mb-2"
                    id="exampleModalLabel"
                    style={{ fontWeight: 'bold' }}
                  >
                    Products/Categories
                  </h6>
                  <div className={`${styles.modal_body} mt-1`}>
                    <div className="row my-0 py-0">
                      <div className="col-7 py-0 my-0">
                        <label htmlFor="allprod">
                          <input
                            type="checkbox"
                            checked={selectAllProductCategory}
                            onChange={handleSelectAllProductCategories}
                          />
                          &nbsp;&nbsp;All Products
                        </label>
                      </div>
                      <div className="col-5 py-0 my-0">
                        <span
                          className={`${styles.span}`}
                          data-toggle="collapse"
                          data-target="#collapseExample01"
                          aria-expanded="false"
                          aria-controls="collapseExample"
                        >
                          <label>
                            <input type="checkbox" name="" />
                            <span>
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="16"
                                height="16"
                                fill="currentColor"
                                class="bi bi-chevron-down"
                                viewBox="0 0 16 16"
                              >
                                <path
                                  fill-rule="evenodd"
                                  d="M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z"
                                />
                              </svg>
                              {/* <i className="bi bi-chevron-down"></i> */}
                            </span>
                          </label>
                        </span>
                      </div>
                    </div>
                    <div className="collapse" id="collapseExample01">
                      <div
                        className="card card-body pl-5 pb-0"
                        style={{ border: 'none' }}
                      >
                        <p>
                          <input
                            type="text"
                            className="form-control"
                            placeholder="Search..."
                            name=""
                            id=""
                            onChange={handleSearchProduct}
                            value={searchProducts}
                          />
                        </p>
                        {!isProductCatPending &&
                          productCatData?.length > 0 &&
                          productCatData?.slice(0, 5).map((el, i) => {
                            const filteredProducts = el?.products?.filter(
                              (product) =>
                                product?.product_name
                                  ?.toLowerCase()
                                  .includes(searchCategory.toLowerCase())
                            );
                            return (
                              <>
                                <div className="p-2 d-md-flex" key={i}>
                                  <div className="mr-3 mt-1">
                                    <input
                                      type="radio"
                                      checked={selectedProductCatIds.includes(
                                        el?._id
                                      )}
                                      onChange={() =>
                                        handleProductCatCheckBoxChange1(el?._id)
                                      }
                                    />
                                  </div>
                                  <Avatar
                                    className={`${styles.avatrr} mr-3 floadt-md-left`}
                                    alt={el?.category_name}
                                    src={el?.category_image}
                                  />
                                  <div className=" ">
                                    <p
                                      className="mb-0 text-left"
                                      style={{ fontSize: '14px' }}
                                    >
                                      <strong>{el?.category_name}</strong>
                                    </p>
                                    <p
                                      className="mb-0 text-left"
                                      style={{ fontSize: '10px' }}
                                    >
                                      {el?.number_of_product < 2
                                        ? el?.number_of_product + ' product'
                                        : el?.number_of_product + ' products'}
                                    </p>
                                  </div>
                                  <div>
                                    <span
                                      className={`${styles.span}`}
                                      data-toggle="collapse"
                                      data-target={`#collapseExample${el?._id}`}
                                      aria-expanded="false"
                                      aria-controls={`collapseExample${el?._id}`}
                                      onClick={() =>
                                        handleFetchCategoryProducts(el?._id)
                                      }
                                    >
                                      <label>
                                        <input type="checkbox" name="" />
                                        <span>
                                          <svg
                                            xmlns="http://www.w3.org/2000/svg"
                                            width="16"
                                            height="16"
                                            fill="currentColor"
                                            class="bi bi-chevron-down"
                                            viewBox="0 0 16 16"
                                          >
                                            <path
                                              fill-rule="evenodd"
                                              d="M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z"
                                            />
                                          </svg>
                                        </span>
                                      </label>
                                    </span>
                                  </div>
                                </div>
                                <div
                                  className="collapse"
                                  id={`collapseExample${el?._id}`}
                                >
                                  <div
                                    className="card card-body pl-5 pb-0"
                                    style={{ border: 'none' }}
                                  >
                                    <p>
                                      <input
                                        type="text"
                                        className="form-control"
                                        placeholder="Search..."
                                        name=""
                                        id=""
                                        onChange={handleSearchCategory}
                                        value={searchCategory}
                                      />
                                    </p>
                                    {!isCategoryPending &&
                                      filteredProducts?.length > 0 &&
                                      filteredProducts
                                        ?.slice(0, 5)
                                        .map((el, i) => {
                                          return (
                                            <div
                                              className="p-2 d-md-flex"
                                              key={i}
                                            >
                                              <div className="mr-3 mt-1">
                                                <input
                                                  type="checkbox"
                                                  checked={selectedCategoryIds.includes(
                                                    el?._id
                                                  )}
                                                  onChange={() =>
                                                    handleCategoryBoxChange(
                                                      el?._id
                                                    )
                                                  }
                                                />
                                              </div>
                                              <div className=" ">
                                                <p
                                                  className="mb-0 text-left"
                                                  style={{ fontSize: '14px' }}
                                                >
                                                  <strong>
                                                    {el?.product_name}
                                                  </strong>
                                                </p>
                                              </div>
                                            </div>
                                          );
                                        })}
                                    {!isCategoryPending &&
                                      filteredProducts?.length < 1 && (
                                        <p>
                                          <i>No Record Found...</i>
                                        </p>
                                      )}
                                    <div className="d-flex justify-content-center">
                                      {isCategoryPending && (
                                        <BallTriangle
                                          height={30}
                                          width={35}
                                          radius={5}
                                          color="#af3585"
                                          ariaLabel="ball-triangle-loading"
                                          wrapperClass={{}}
                                          wrapperStyle=""
                                          visible={true}
                                        />
                                      )}
                                    </div>
                                  </div>
                                </div>
                              </>
                            );
                          })}
                        {!isProductCatPending && productCatData?.length < 1 && (
                          <p>
                            <i>No Records Found...</i>
                          </p>
                        )}
                        <div className="d-flex justify-content-center">
                          {isProductCatPending && (
                            <BallTriangle
                              height={50}
                              width={55}
                              radius={5}
                              color="#af3585"
                              ariaLabel="ball-triangle-loading"
                              wrapperClass={{}}
                              wrapperStyle=""
                              visible={true}
                            />
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div
                className={`${styles.bordered_sect} col-md-6`}
                style={{
                  borderLeft: '2px solid #ddd',
                }}
              >
                <div className="allprod_wrapper">
                  <h6
                    className="modal-title mb-2"
                    id="exampleModalLabel"
                    style={{ fontWeight: 'bold' }}
                  >
                    Location/Store
                  </h6>
                  <div className={`${styles.modal_body}`}>
                    <div className="row my-0 py-0">
                      <div className="col-5 py-0 my-0">
                        <label htmlFor="country">
                          <input
                            type="checkbox"
                            checked={selectAllStates}
                            onChange={handleSelectAllStates}
                          />
                          &nbsp;&nbsp; Nigeria
                        </label>
                      </div>
                      <div className="col-5 py-0 my-0">
                        <span
                          className={`${styles.span}`}
                          data-toggle="collapse"
                          data-target="#collapseExample02"
                          aria-expanded="false"
                          aria-controls="collapseExample"
                        >
                          <label>
                            <input type="checkbox" name="" />
                            <span>
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="16"
                                height="16"
                                fill="currentColor"
                                class="bi bi-chevron-down"
                                viewBox="0 0 16 16"
                              >
                                <path
                                  fill-rule="evenodd"
                                  d="M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z"
                                />
                              </svg>
                              {/* <i className="bi bi-chevron-down"></i> */}
                            </span>
                          </label>
                        </span>
                      </div>
                    </div>

                    <div className="collapse pl-1" id="collapseExample02">
                      <div
                        className="card card-body pl-5 pb-0"
                        style={{ border: 'none' }}
                      >
                        <p>
                          <input
                            type="text"
                            className="form-control"
                            placeholder="Search..."
                            name=""
                            id=""
                            onChange={handleSearchState}
                            value={searchStates}
                          />
                        </p>
                        <div className="row mt-3">
                          {!loadingState &&
                            states &&
                            states[0]?.states &&
                            states[0]?.states
                              .slice(0, 14)
                              .map((state, index) => {
                                const id = `state-${index}`;
                                return (
                                  <div
                                    className="col-6 py-0 my-0 d-md-flex"
                                    key={index}
                                  >
                                    <label htmlFor={id}>
                                      <input
                                        type="checkbox"
                                        id={id}
                                        className="mr-2"
                                        checked={selectedState.includes(state)}
                                        onChange={() =>
                                          handleStateChange2(state)
                                        }
                                      />
                                    </label>
                                    <div>{state}</div>
                                  </div>
                                );
                              })}
                        </div>
                        {!loadingState && states.length < 1 && (
                          <p>
                            <i>No Records Found...</i>
                          </p>
                        )}
                        <div className="d-flex justify-content-center">
                          {loadingState && (
                            <BallTriangle
                              height={50}
                              width={55}
                              radius={5}
                              color="#af3585"
                              ariaLabel="ball-triangle-loading"
                              wrapperClass={{}}
                              wrapperStyle=""
                              visible={true}
                            />
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="mt-5">
              <button
                className="btn btn-primary w-100 d-block"
                data-dismiss="modal"
                aria-label="Close"
              >
                Proceed
              </button>
            </div>
          </div>
        </GlobalModal>

        <GlobalModal
          open={statFilter1}
          onClose={handleStatFilter1}
          position="absolute"
          top="50%"
          left="50%"
          transform="translate(-50%, -50%)"
          width="740px !important"
          maxHeight="500px !important"
          overflow="auto"
          bgcolor="#F5F5F5"
          border="1px solid #F5F5F5"
          borderRadius="5px"
          boxShadow="24"
          background="#FFFFFF"
          p="25px"
        >
          <div className={`${styles.modal_content}`}>
            <div className={`${styles.modal_header} mb-0`}>
              <span
                className="ml-auto"
                onClick={handleStatFilter1}
                style={{ cursor: 'pointer' }}
              >
                <img src="/assets/icons/x.svg" alt="" />
              </span>
            </div>
            <div className={`${styles.modal_content} row`}>
              <div className="col-md-6">
                <div className="allprod_wrapper mt-m3">
                  <h6
                    className="modal-title mb-2"
                    id="exampleModalLabel"
                    style={{ fontWeight: 'bold' }}
                  >
                    Products/Categories
                  </h6>
                  <div className={`${styles.modal_body} mt-1`}>
                    <div className="row my-0 py-0">
                      <div className="col-7 py-0 my-0">
                        <label htmlFor="allprod">
                          <input
                            type="checkbox"
                            checked={selectAllProductCategory}
                            onChange={handleSelectAllProductCategories}
                          />
                          &nbsp;&nbsp;All Products
                        </label>
                      </div>
                      <div className="col-5 py-0 my-0">
                        <span
                          className={`${styles.span}`}
                          data-toggle="collapse"
                          data-target="#collapseExample01"
                          aria-expanded="false"
                          aria-controls="collapseExample"
                        >
                          <label>
                            <input type="checkbox" name="" />
                            <span>
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="16"
                                height="16"
                                fill="currentColor"
                                class="bi bi-chevron-down"
                                viewBox="0 0 16 16"
                              >
                                <path
                                  fill-rule="evenodd"
                                  d="M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z"
                                />
                              </svg>
                              {/* <i className="bi bi-chevron-down"></i> */}
                            </span>
                          </label>
                        </span>
                      </div>
                    </div>
                    <div className="collapse" id="collapseExample01">
                      <div
                        className="card card-body pl-5 pb-0"
                        style={{ border: 'none' }}
                      >
                        <p>
                          <input
                            type="text"
                            className="form-control"
                            placeholder="Search..."
                            name=""
                            id=""
                            onChange={handleSearchProduct}
                            value={searchProducts}
                          />
                        </p>
                        {!isProductCatPending &&
                          productCatData?.length > 0 &&
                          productCatData?.slice(0, 5).map((el, i) => {
                            const filteredProducts = el?.products?.filter(
                              (product) =>
                                product?.product_name
                                  ?.toLowerCase()
                                  .includes(searchCategory.toLowerCase())
                            );
                            return (
                              <>
                                <div className="p-2 d-md-flex" key={i}>
                                  <div className="mr-3 mt-1">
                                    <input
                                      type="checkbox"
                                      checked={selectedProductCatIds.includes(
                                        el?._id
                                      )}
                                      onChange={() =>
                                        handleProductCatCheckBoxChange(el?._id)
                                      }
                                    />
                                  </div>
                                  <Avatar
                                    className={`${styles.avatrr} mr-3 floadt-md-left`}
                                    alt={el?.category_name}
                                    src={el?.category_image}
                                  />
                                  <div className=" ">
                                    <p
                                      className="mb-0 text-left"
                                      style={{ fontSize: '14px' }}
                                    >
                                      <strong>{el?.category_name}</strong>
                                    </p>
                                    <p
                                      className="mb-0 text-left"
                                      style={{ fontSize: '10px' }}
                                    >
                                      {el?.number_of_product < 2
                                        ? el?.number_of_product + ' product'
                                        : el?.number_of_product + ' products'}
                                    </p>
                                  </div>
                                  <div>
                                    <span
                                      className={`${styles.span}`}
                                      data-toggle="collapse"
                                      data-target={`#collapseExample${el?._id}`}
                                      aria-expanded="false"
                                      aria-controls={`collapseExample${el?._id}`}
                                      onClick={() =>
                                        handleFetchCategoryProducts(el?._id)
                                      }
                                    >
                                      <label>
                                        <input type="checkbox" name="" />
                                        <span>
                                          <svg
                                            xmlns="http://www.w3.org/2000/svg"
                                            width="16"
                                            height="16"
                                            fill="currentColor"
                                            class="bi bi-chevron-down"
                                            viewBox="0 0 16 16"
                                          >
                                            <path
                                              fill-rule="evenodd"
                                              d="M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z"
                                            />
                                          </svg>
                                        </span>
                                      </label>
                                    </span>
                                  </div>
                                </div>
                                <div
                                  className="collapse"
                                  id={`collapseExample${el?._id}`}
                                >
                                  <div
                                    className="card card-body pl-5 pb-0"
                                    style={{ border: 'none' }}
                                  >
                                    <p>
                                      <input
                                        type="text"
                                        className="form-control"
                                        placeholder="Search..."
                                        name=""
                                        id=""
                                        onChange={handleSearchCategory}
                                        value={searchCategory}
                                      />
                                    </p>
                                    {!isCategoryPending &&
                                      filteredProducts?.length > 0 &&
                                      filteredProducts
                                        ?.slice(0, 5)
                                        .map((el, i) => {
                                          return (
                                            <div
                                              className="p-2 d-md-flex"
                                              key={i}
                                            >
                                              <div className="mr-3 mt-1">
                                                <input
                                                  type="checkbox"
                                                  checked={selectedCategoryIds.includes(
                                                    el?._id
                                                  )}
                                                  onChange={() =>
                                                    handleCategoryBoxChange(
                                                      el?._id
                                                    )
                                                  }
                                                />
                                              </div>
                                              <div className=" ">
                                                <p
                                                  className="mb-0 text-left"
                                                  style={{ fontSize: '14px' }}
                                                >
                                                  <strong>
                                                    {el?.product_name}
                                                  </strong>
                                                </p>
                                              </div>
                                            </div>
                                          );
                                        })}
                                    {!isCategoryPending &&
                                      filteredProducts?.length < 1 && (
                                        <p>
                                          <i>No Record Found...</i>
                                        </p>
                                      )}
                                    <div className="d-flex justify-content-center">
                                      {isCategoryPending && (
                                        <BallTriangle
                                          height={30}
                                          width={35}
                                          radius={5}
                                          color="#af3585"
                                          ariaLabel="ball-triangle-loading"
                                          wrapperClass={{}}
                                          wrapperStyle=""
                                          visible={true}
                                        />
                                      )}
                                    </div>
                                  </div>
                                </div>
                              </>
                            );
                          })}
                        {!isProductCatPending && productCatData?.length < 1 && (
                          <p>
                            <i>No Records Found...</i>
                          </p>
                        )}
                        <div className="d-flex justify-content-center">
                          {isProductCatPending && (
                            <BallTriangle
                              height={50}
                              width={55}
                              radius={5}
                              color="#af3585"
                              ariaLabel="ball-triangle-loading"
                              wrapperClass={{}}
                              wrapperStyle=""
                              visible={true}
                            />
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div
                className={`${styles.bordered_sect} col-md-6`}
                style={{
                  borderLeft: '2px solid #ddd',
                }}
              >
                <div className="allprod_wrapper">
                  <h6
                    className="modal-title mb-2"
                    id="exampleModalLabel"
                    style={{ fontWeight: 'bold' }}
                  >
                    Location
                  </h6>
                  <div className={`${styles.modal_body}`}>
                    <div className="row my-0 py-0">
                      <div className="col-5 py-0 my-0">
                        <label htmlFor="country">Nigeria</label>
                      </div>
                      <div className="col-5 py-0 my-0">
                        <span
                          className={`${styles.span}`}
                          data-toggle="collapse"
                          data-target="#collapseExample02"
                          aria-expanded="false"
                          aria-controls="collapseExample"
                        >
                          <label>
                            <input type="checkbox" name="" />
                            <span>
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="16"
                                height="16"
                                fill="currentColor"
                                class="bi bi-chevron-down"
                                viewBox="0 0 16 16"
                              >
                                <path
                                  fill-rule="evenodd"
                                  d="M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z"
                                />
                              </svg>
                              {/* <i className="bi bi-chevron-down"></i> */}
                            </span>
                          </label>
                        </span>
                      </div>
                    </div>

                    <div className="collapse pl-1" id="collapseExample02">
                      <div
                        className="card card-body pl-5 pb-0"
                        style={{ border: 'none' }}
                      >
                        <p>
                          <input
                            type="text"
                            className="form-control"
                            placeholder="Search..."
                            name=""
                            id=""
                            onChange={handleSearchState3}
                            value={searchStates3}
                          />
                        </p>
                        <div className="row mt-3">
                          {!loadingState &&
                            states?.length > 0 &&
                            states?.slice(0, 14).map((el, i) => {
                              return (
                                <div
                                  className="col-6 py-0 my-0 d-md-flex"
                                  key={i}
                                >
                                  <label htmlFor={`state-${i}`}>
                                    <input
                                      type="radio"
                                      id={`state-${i}`}
                                      className="mr-2"
                                      checked={selectedState3.includes(el)}
                                      onChange={() => handleStateChange3(el)}
                                    />
                                  </label>
                                  <div>{el}</div>
                                </div>
                              );
                            })}
                        </div>
                        {!loadingState && states.length < 1 && (
                          <p>
                            <i>No Records Found...</i>
                          </p>
                        )}
                        <div className="d-flex justify-content-center">
                          {loadingState && (
                            <BallTriangle
                              height={50}
                              width={55}
                              radius={5}
                              color="#af3585"
                              ariaLabel="ball-triangle-loading"
                              wrapperClass={{}}
                              wrapperStyle=""
                              visible={true}
                            />
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="mt-5">
              <button
                className="btn btn-primary w-100 d-block"
                data-dismiss="modal"
                aria-label="Close"
              >
                Proceed
              </button>
            </div>
          </div>
        </GlobalModal>

        <GlobalModal
          open={statFilter01}
          onClose={handleStatFilter01}
          position="absolute"
          top="50%"
          left="50%"
          transform="translate(-50%, -50%)"
          width="740px !important"
          maxHeight="500px !important"
          overflow="auto"
          bgcolor="#F5F5F5"
          border="1px solid #F5F5F5"
          borderRadius="5px"
          boxShadow="24"
          background="#FFFFFF"
          p="25px"
        >
          <div className={`${styles.modal_content}`}>
            <div className={`${styles.modal_header} mb-0`}>
              <span
                className="ml-auto"
                onClick={handleStatFilter01}
                style={{ cursor: 'pointer' }}
              >
                <img src="/assets/icons/x.svg" alt="" />
              </span>
            </div>
            <div className={`${styles.modal_content} row`}>
              <div className="col-md-6">
                <div className="allprod_wrapper mt-m3">
                  <h6
                    className="modal-title mb-2"
                    id="exampleModalLabel"
                    style={{ fontWeight: 'bold' }}
                  >
                    Products
                  </h6>
                  <p className="ml-md-3">Select Categories</p>
                  <div className={`${styles.modal_body} mt-1`}>
                    <div
                      className="card card-body pl-3 pb-0"
                      style={{ border: 'none' }}
                    >
                      <p>
                        <input
                          type="text"
                          className="form-control"
                          placeholder="Search..."
                          name=""
                          id=""
                          onChange={handleSearchProduct}
                          value={searchProducts}
                        />
                      </p>
                      {!isProductCatPending &&
                        productCatData?.length > 0 &&
                        productCatData?.slice(0, 5).map((el, i) => {
                          const filteredProducts = el?.products?.filter(
                            (product) =>
                              product?.product_name
                                ?.toLowerCase()
                                .includes(searchCategory.toLowerCase())
                          );
                          return (
                            <>
                              <div className="p-2 pl-3 d-md-flex" key={i}>
                                <div className="mr-3 mt-1">
                                  <input
                                    type="checkbox"
                                    checked={selectedProductCatIds.includes(
                                      el?._id
                                    )}
                                    onChange={() =>
                                      handleProductCatCheckBoxChange(el?._id)
                                    }
                                  />
                                </div>
                                <Avatar
                                  className={`${styles.avatrr} mr-3 floadt-md-left`}
                                  alt={el?.category_name}
                                  src={el?.category_image}
                                />
                                <div className=" ">
                                  <p
                                    className="mb-0 text-left"
                                    style={{ fontSize: '14px' }}
                                  >
                                    <strong>{el?.category_name}</strong>
                                  </p>
                                  <p
                                    className="mb-0 text-left"
                                    style={{ fontSize: '10px' }}
                                  >
                                    {el?.number_of_product < 2
                                      ? el?.number_of_product + ' product'
                                      : el?.number_of_product + ' products'}
                                  </p>
                                </div>
                                <div></div>
                              </div>
                            </>
                          );
                        })}
                      {!isProductCatPending && productCatData?.length < 1 && (
                        <p>
                          <i>No Records Found...</i>
                        </p>
                      )}
                      <div className="d-flex justify-content-center">
                        {isProductCatPending && (
                          <BallTriangle
                            height={50}
                            width={55}
                            radius={5}
                            color="#af3585"
                            ariaLabel="ball-triangle-loading"
                            wrapperClass={{}}
                            wrapperStyle=""
                            visible={true}
                          />
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div
                className={`${styles.bordered_sect} col-md-6`}
                style={{
                  borderLeft: '2px solid #ddd',
                }}
              >
                <div className="allprod_wrapper">
                  <h6
                    className="modal-title mb-2"
                    id="exampleModalLabel"
                    style={{ fontWeight: 'bold' }}
                  >
                    Location
                  </h6>
                  <div className={`${styles.modal_body}`}>
                    <div className="row my-0 py-0">
                      <div className="col-5 py-0 my-0">
                        <label htmlFor="country">Nigeria</label>
                      </div>
                      <div className="col-5 py-0 my-0">
                        <span
                          className={`${styles.span}`}
                          data-toggle="collapse"
                          data-target="#collapseExample02"
                          aria-expanded="false"
                          aria-controls="collapseExample"
                        >
                          <label>
                            <input type="checkbox" name="" />
                            <span>
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="16"
                                height="16"
                                fill="currentColor"
                                class="bi bi-chevron-down"
                                viewBox="0 0 16 16"
                              >
                                <path
                                  fill-rule="evenodd"
                                  d="M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z"
                                />
                              </svg>
                              {/* <i className="bi bi-chevron-down"></i> */}
                            </span>
                          </label>
                        </span>
                      </div>
                    </div>

                    <div className="collapse pl-1" id="collapseExample02">
                      <div
                        className="card card-body pl-1 pb-0"
                        style={{ border: 'none' }}
                      >
                        <p>
                          <input
                            type="text"
                            className="form-control"
                            placeholder="Search..."
                            name=""
                            id=""
                            onChange={handleSearchState3}
                            value={searchStates3}
                          />
                        </p>
                        <div className="row mt-3">
                          {!loadingState &&
                            states?.length > 0 &&
                            states?.slice(0, 14).map((el, i) => {
                              return (
                                <div
                                  className="col-6 py-0 my-0 d-md-flex"
                                  key={i}
                                >
                                  <label htmlFor={`state-${i}`}>
                                    <input
                                      type="radio"
                                      id={`state-${i}`}
                                      className="mr-2"
                                      checked={selectedState3.includes(el)}
                                      onChange={() => handleStateChange3(el)}
                                    />
                                  </label>
                                  <div>{el}</div>
                                </div>
                              );
                            })}
                        </div>
                        {!loadingState && states.length < 1 && (
                          <p>
                            <i>No Records Found...</i>
                          </p>
                        )}
                        <div className="d-flex justify-content-center">
                          {loadingState && (
                            <BallTriangle
                              height={50}
                              width={55}
                              radius={5}
                              color="#af3585"
                              ariaLabel="ball-triangle-loading"
                              wrapperClass={{}}
                              wrapperStyle=""
                              visible={true}
                            />
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="mt-5">
              <button
                className="btn btn-primary w-100 d-block"
                data-dismiss="modal"
                aria-label="Close"
              >
                Proceed
              </button>
            </div>
          </div>
        </GlobalModal>
      </div>
    </div>
  );
}
